// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mygroup .title-img-area .nature-text .nature-sub h5 {
    width: 100%;
    font-weight: 400;
    font-size: 20px;
    color: #0f062b;
    margin-bottom: 0;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.mygroup .title-img-area .nature-text .nature-sub .group-title {
    width: 110%;
    font-weight: 500;
    font-size: 20px;
    color: #0f062b;
    margin-bottom: 0;
    /*white-space: nowrap;*/
    /*overflow: hidden;*/
    /*text-overflow: ellipsis;*/
    min-width: 40px;
    padding: 0 0px;
}


.mygroup .group-title:focus {
    /*background: #fff;*/
    border: 1px solid #888;
    border-radius: 3px;
}

.meetingCal{
    cursor: pointer;
}

.mygroup .title-img-area .nature-text .nature-btn-aera .btn-invite button,
.mygroup .title-img-area .nature-text .nature-btn-aera button.like {
    border: 0;
    outline: 0;
    background: #ffffff;
    border: 1px solid #f8f8f8;
    border-radius: 4px;
    width: 32px;
    height: 32px;
}

.addEvent{
    font-weight: 500;
    font-size: 15px;
    color: #6c757d;
    margin-left: 10px;
}

::ng-deep .owl-carousel.owl-loading {
    opacity: unset;
    display: block;
}

/* mygroup style */
/*.mygroup .title-img-area .nature-div {*/
/*    overflow: hidden;*/
/*    min-width: 35vh;*/
/*    width: fit-content;*/
/*    position: relative;*/
/*    background-color: #eaeaea;*/
/*    display: flex;*/
/*    border-radius: 8px;*/
/*}*/

.joinGroup button {
    border: 1px solid #6c2fbb;
    padding: 4px 20px;
    font-size: 15px;
    border-radius: 0.2rem;
    color: #fff;
    background-color: #6c2fbb;
    margin-top: 10px;
}

.QRcode p {
    font-size: 15px;
    font-weight: 500;
    color: black;
}

.QRcode {
    display: flex;
    align-items: flex-start;
    margin-top: 5px;
    cursor: pointer;
    width: -moz-fit-content;
    width: fit-content;
}

.mygroup .title-img-area .nature-div {
    cursor: pointer;
    display: flex;
    justify-content: center;
    height: 180px;
    min-width: 280px;
    max-width: 280px;
    width: 100%;
    border-radius: 16px;
    overflow: hidden;
    position: relative;
    /* background: #eaeaea; */
}

button.edit {
    margin-left: 10px;
    top: 6px;
    /* right: 36px; */
    /* right: -43px; */
    right: 5px;
    content: "";
    width: 28px;
    height: 28px;
    background: transparent;
    border-radius: 6px;
    border: 0;
    overflow: hidden;
}

.mygroup .title-img-area .nature-div button.edit {
    position: absolute;
}

.mygroup .title-img-area .nature-img {
    max-width: 419px;
    width: 100%;
    max-height: 215px;
    height: 100%;
    border-radius: 8px;
    position: relative;
}

.mygroup .expandImg {
    position: absolute;
    top: 7px;
    z-index: 1;
    right: 40px;
    background: #7a2df9;
    padding: 0 3px;
    border: 1px solid white;
}

.mygroup .expandImg img {
    width: 18px;
}

.dropExpand {
    position: absolute;
    right: 0;
}

.dropExpand .dropdown-menu.show {
    position: absolute;
    transform: translate3d(-36px, 33px, 0px);
    top: -1px !important;
    left: -65px !important;
    min-width: 4rem !important;
    text-align: center !important;
    background-color: white !important;
    padding: 0 !important;
}

.dropdown-toggle::after {
    display: none;
}

a.dropdown-item.activeImgSetting {
    background-color: #f1eafe;
    color: #6c2fbb;
}

.mygroup .title-img-area .nature-text {
    width: 100%;
    /*padding-left: 20px;*/
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    margin: 15px 0px;
}

.mygroup .title-img-area .nature-text .nature-sub {
    /*display: flex;*/
    align-items: center;
    padding-left: 25px;
    gap: 10px;
}

.mygroup .title-img-area .nature-text .nature-sub button.edit {
    width: 27.54px;
    height: 27.54px;
    background: transparent;
    border-radius: 6px;
    border: 0;
    outline: 0;
    overflow: hidden;
}

.mygroup .title-img-area .nature-text .nature-btn-aera .btn-invite span {
    font-weight: 400;
    font-size: 15px;
    color: #727272;
}

.btn-invite button .fa-sort {
    font-size: 14px;
}

.mygroup .title-img-area .nature-text .nature-btn-aera .btn-invite button {
    font-size: 21px;
    color: #0f062b;
    font-weight: 900;
}

.mygroup .title-img-area .emo {
    width: 100%;
    max-width: 800px;
    font-weight: 500;
    font-size: 15px;
    color: #727272;
    min-height: 30px;
    margin-bottom: 0;
    display: flex;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    padding: 0 0px;
    min-width: 40px;
}

.mygroup .title-img-area .emo:focus {
    /*background: #fff;*/
    border: 1px solid #888;
    border-radius: 3px;
}

.mygroup .title-img-area .private-div {
    display: flex;
    align-items: center;
    gap: 6px;
}

.mygroup .title-img-area .private-div p {
    font-weight: 500;
    font-size: 15px;
    color: #bcbcbc;
    margin-bottom: 0;
    margin-top: 2px;
}

.mygroup .title-img-area .private-div a {
    text-decoration: none;
}

.mygroup .admin-area h2 {
    font-weight: 400;
    font-size: 26px;
    color: #0f062b;
    margin-bottom: 0;
}

.edit-title-group .edit {
    display: none;
}

.edit-title-group:hover .edit {
    display: inline-flex;
}

.mygroup .admin-area .add-title {
    font-weight: 400;
    font-size: 26px;
    color: #0f062b;
    margin-bottom: 0;
    min-width: 40px;
    padding: 0 2px;
}

.mygroup .admin-area .add-title:focus {
    /*background: #fff;*/
    border: 1px solid #888;
    border-radius: 3px;
}

.btn-subscribe {
    border: 1px solid #6c2fbb;
    padding: 0.25rem 0.5rem;
    font-size: .875rem;
    line-height: 1.5;
    border-radius: 0.2rem;
    display: inline-block;
    font-weight: 400;
    text-align: center;
    vertical-align: middle;
    transition: color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out;
}

.btn-subscribe.subscribe:hover {
    color: #fff;
    background-color: #6c2fbb;
}

.btn-subscribe.subscribe {
    color: #6c2fbb;
    background-color: #fff;
    cursor: pointer;
}

.btn-subscribe.subscribed {
    color: #fff;
    background-color: #6c2fbb;
}

.btn-invite {
    justify-content: flex-end;
    margin: 20px 0;
}

.btn-invite span {
    cursor: pointer;
    font-weight: 400;
    font-size: 15px;
    color: #6c2fbb;
}

.btn-invite button {
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 21px;
    color: #6c2fbb;
    /*font-weight: 900;*/
    outline: 0;
    background: #e1e1f9;
    border: none;
    border-radius: 4px;
    width: 26px;
    height: 26px;
}
.admin-select {
    font-size: 14px;
    padding: 4px 10px;
    border: none;
}
.grp-edition {
    min-width: auto;
}
.btn-custom  {
    padding-right: 35px;
}
.btn-custom .group {
    background: transparent;
    outline: none;
    border: none;
    color: #6c2fbb;
    font-weight: 600;
    text-align: right;
    margin: .5rem !important;
    /*white-space: nowrap;*/
}

.mygroup .admin-area .border-group {
    background: #FFFFFF;
    border: 1px solid #F8F8F8;
    border-radius: 16px;
    padding: 10px 35px;
}

.image-button-box {
    display: flex;
    /*align-items: end;*/
    /*justify-content: space-between;*/
    gap: 10px;
}
.show-admin {
    margin-bottom: 10px;
}
.view-all {
    padding-top: 30px;
}

.view-all button {
    border: none;
    font-weight: 700;
    font-size: 12px;
    color: #6c2fbb;
    text-decoration: none;
    background-color: transparent;
}

.view-all button span {
    line-height: 4px;
    font-size: 16px;
}

.mygroup .admin-area .activeted {
    display: flex;
    flex-direction: column;
    text-align: center;
    align-items: center;
    gap: 16px;
    margin-top: 8px;
}
.admin-img-profile {
    position: relative;
    width: -moz-fit-content;
    width: fit-content;
    margin-inline: auto;
}
.admin-img-profile::after {
    position: absolute;
    top: -2px;
    right: -4px;
    width: 10px;
    height: 10px;
    background: #ff0909;
    content: "";
    border-radius: 50%;
}
.mygroup .admin-area .activeted .active-imger {
    cursor: pointer;
    position: relative;
    width: 50px;
    height: 50px;
    border-radius: 9px;
    box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15);
}

.mygroup .admin-area .activeted .active-imger.active::after {
    position: absolute;
    top: -2px;
    right: -4px;
    width: 10px;
    height: 10px;
    background: #ff0909;
    content: "";
    border-radius: 50%;
}

.mygroup .admin-area .activeted .active-imger img {
    width: 100%;
    height: 100%;
    border-radius: 9px;
    object-fit: cover;
}

.mygroup .admin-area .activeted h6 {
    cursor: pointer;
    font-weight: 400;
    font-size: 16px;
    color: #000000;
    margin-bottom: 0;
}

.mygroup .admin-area .activeted p {
    font-weight: 400;
    font-size: 14px;
    color: #727272;
    margin-bottom: 0;
}

.mygroup .admin-area .activeted-btns {
    display: flex;
    align-items: center;
    /* width: fit-content; */
    gap: 8px;
    /* margin-top: 8px; */
}

.mygroup .admin-area .activeted-btns button {
    border: none;
    width: 30px;
    height: 30px;
    background: #F8FAFB;
    border-radius: 4px;
    color: #0F062B;
    font-size: 20px;
    font-weight: 900;
    display: flex;
    align-items: center;
    justify-content: center;
}

.mygroup .admin-area .activeted-btns p {
    font-weight: 400;
    font-size: 15px;
    color: #727272;
    margin-bottom: 0;
}

.mygroup .content-page {
    background: #ffffff;
    border: 1px solid #f8f8f8;
    border-radius: 16px;
    padding: 10px 40px 10px 40px;
}

.mygroup .content-page .content-area img {
    /*border-radius: 8px;*/
    /*width: 100%;*/
    max-width: 100%;
    object-fit: cover;
    /* object-fit: contain; */
}

.mygroup .content-page .content-area h4 {
    font-weight: 400;
    font-size: 16px;
    color: #0f062b;
    margin-top: 15px;
    margin-bottom: 15px !important;
}

.content-area .img-box {
    aspect-ratio: 16/9;
    cursor: pointer;
    width: 100%;
    /*height: 270px;*/
    /*height: 250px;*/
    border-radius: 10px;
    overflow: hidden;
    display: flex;
    /*position: relative;*/
    background: #f8f9fa;
    text-align: center;
    justify-content: center;
}



.rag-body {
    max-height: 80vh;
    overflow: auto;
}

.rag-list {
    width: 500px;
    max-width: 100%;
    border: solid 1px #ccc;
    min-height: 60px;
    display: block;
    background: white;
    border-radius: 4px;
    overflow: hidden;
}

.rag-list.cdk-drop-list-dragging .rag-box:not(.cdk-drag-placeholder) {
    transition: transform 250ms cubic-bezier(0, 0, 0.2, 1);
}

.rag-box:last-child {
    border: none;
}

.rag-box {
    padding: 10px;
    border-bottom: solid 1px #ccc;
    color: rgba(0, 0, 0, 0.87);
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    box-sizing: border-box;
    cursor: move;
    background: white;
    font-size: 14px;
    z-index: 99999;
}

#reOrderGroupTab .rag-box,
#reOrderGroupTopic .rag-box {
    padding: 10px;
    border-bottom: solid 1px #ccc;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    box-sizing: border-box;
    cursor: move;
    background: white;
    z-index: 99999;
    font-size: 18px;
    font-weight: 500;
    color: #878395;
}

.rag-box:last-child {
    border: none;
}

.rag-custom-placeholder {
    background: #ccc;
    border: dotted 3px #999;
    min-height: 110px;
    transition: transform 250ms cubic-bezier(0, 0, 0.2, 1);
}

#reOrderGroupTab .rag-custom-placeholder,
#reOrderGroupTopic .rag-custom-placeholder {
    background: #ccc;
    border: dotted 3px #999;
    min-height: 50px;
    transition: transform 250ms cubic-bezier(0, 0, 0.2, 1);
}

.rag-img-box {
    width: 100px;
    height: 80px;
    margin-right: 10px;
    display: flex;
    justify-content: center;
    border-radius: 8px;
    background: #f8f9fa;
}

.rag-img {
    height: 100%;
    width: 100%;
    object-fit: contain;
}
::ng-deep .my-dialog {
    justify-content: center;
}
::ng-deep .my-dialog .mdc-dialog {
    display: flex !important
}

::ng-deep .my-dialog .mdc-dialog__container {
    width: 500px !important;
}

::ng-deep .my-dialog .mdc-dialog__container {
    width: 500px !important;
}

::ng-deep .cdk-overlay-pane.questionnairesDashboard {
    background: #f8fafb;
    margin-block: 30px !important;
    position: relative !important;
    height: calc(100vh - 50px) !important;
}
::ng-deep .cdk-overlay-pane.questionnairesDashboard .mat-mdc-dialog-surface {
    overflow: hidden;
}

@media (max-width: 1700px) {
    .content-area .img-box {
        height: 240px
    }
}

@media (max-width: 1600px) {
    .content-area .img-box {
        height: 220px
    }
}

@media (max-width: 1440px) {
    .content-area .img-box {
        height: 200px;
    }
    
    ::ng-deep .cdk-overlay-pane.analytics-modal {
        width: 88% !important;
    }
}

@media (max-width: 1200px) {
    .content-area .img-box {
        height: 160px;
    }
}

@media (max-width: 1024px) {
    .content-area .img-box {
        height: 120px;
    }
}


@media (max-width: 1200px) {
    .btn-custom .group {
        max-width: 160px;
        
    }
}
@media (max-width: 480px) {
    ::ng-deep .my-dialog {
        max-width: 98% !important;
    }
}


.dots {
    position: absolute;
    top: 12px;
    right: 35px;
    /*background-color: #000000a2;*/
    background-color: #929292a2;
    display: flex;
    cursor: pointer;
    align-items: center;
    -moz-column-gap: 10px;
         column-gap: 10px;
    padding: 7px 12px;
    border-radius: 5px;
}

.mygroup .discussion {
    display: flex;
    /* align-items: center; */
    gap: 10px;
    width: 100%;
}

.mygroup .discussion .discussion-preview {
    box-shadow: 0 .15rem .25rem rgba(0, 0, 0, .075);
    position: relative;
    border: 1px solid #3d3e3e;
    border-radius: 8px;
    padding: 5px;
    margin: 2px;
    height: 70px;
    width: 70px;
}

.mygroup .discussion .discussion-preview .loader {
    position: absolute;
    border: 5px solid #f3f3f3;
    border-radius: 50%;
    border-top: 5px solid #6c2fbb;
    width: 60px;
    height: 60px;
    /* Safari */
    animation: spin 2s linear infinite;
}

#reOrderGroupTab .rag-title,
#reOrderGroupTopic .rag-title {
    font-size: 18px;
    font-weight: 500;
    color: #878395;
}

.assignBadge p {
    cursor: pointer;
    padding: 4px 10px;
    color: #6e5eff;
    border: 1px solid #6e5eff;
    border-radius: 2rem;
    font-weight: 500;
    width: -moz-fit-content;
    width: fit-content;
    margin-top: 15px;
}

.badge-box .badge-rounded {
    z-index: 0 !important;
    width: 65px;
    height: 65px;
}

.badge-box {
    background: mediumpurple;
    width: 6em;
    height: 6em;
    border-radius: 20%;
    display: inline-block;
    transition: all 0.2s ease;
    box-shadow: 8px 10px 12px 3px rgba(0, 0, 0, 0.2);
    position: relative;
}

.assignBadge p:hover {
    background-color: #6e5eff3b;
}

.selectedBadge {
    position: relative;
    width: -moz-fit-content;
    width: fit-content;
    margin-top: 30px;
}

.selectedBadge .cross-icon {
    position: absolute;
    right: -5px;
    background-color: beige;
    padding: 0 4px;
    z-index: 1;
    background-blend-mode: overlay;
    height: 20px;
    width: 20px;
    border-radius: 50px;
    top: -4px;
    filter: invert(1);
    cursor: pointer;
}

.badgeSvg svg {
    fill: none !important;
    height: 25px !important;
    width: 23px !important;
    margin-left: 5px !important;
}

.actionButton {
    /* position: absolute; */
    bottom: 0;
    display: flex;
    gap: 10px;
    width: 100%;
    justify-content: flex-end;
    padding: 5px;
    background-color: white;
    /* border: 1px solid #959697;
    border-top: 1px solid #d6d6d6; */
    border-left: 1px solid #959697;
    border-right: 1px solid #959697;
    border-bottom: 1px solid #959697;
}

.reply .actionButton {
    bottom: 30px !important;
}

.actionButton button {
    background: #6c2fbb;
    border-radius: 5px !important;
    padding: 4px 8px;
    height: unset !important;
    width: unset !important;
    border: none !important;
}
.actionButton .btnCancel {
    background: #6c2fbb;
    border-radius: 5px !important;
    padding: 4px 8px;
    height: unset !important;
    width: unset !important;
    font-size: 15px;
    color: white;
    border: none !important;
}

.actionButton button img {
    filter: invert(1);
}

.actionButton button label {
    color: white !important;
    padding: 0 !important;
    margin: 0 !important;
}


::ng-deep .comment-text span.spanComment p {
    margin: 0 !important;
}
::ng-deep .comment-text p {
    position: relative !important;
}

::ng-deep .comment-text span.replyComment p {
    margin: 0 !important;
}

::ng-deep .comment-text span.spanComment img {
    height: 100px !important;
    width: 150px !important;
    border-radius: 4px !important;
}

::ng-deep .comment-text span.replyComment p img {
    height: 100px !important;
    width: 150px !important;
    border-radius: 4px !important;
}

#update_comment .modal-dialog {
    max-width: 530px;
}

.dots-dropdown .dropdown-item:active,
.dots-dropdown .dropdown-item:hover {
    background-color: #d3d2d2;
    color: #000;
}


/* Safari */

@keyframes spin {
    0% {
        transform: rotate(0deg);
    }

    100% {
        transform: rotate(360deg);
    }
}

.mygroup .discussion .discussion-preview .delete-btn {
    display: none;
    text-align: center;
    padding: 2px 5px;
    background: #D9D9D9;
    border-radius: 100%;
    position: absolute;
    line-height: 1;
    right: -10px;
    top: -10px;
}

.mygroup .discussion .discussion-preview:hover .delete-btn {
    display: block;
}

.mygroup .discussion .mini-discussion {
    width: 100%;
    position: relative;
}

.mygroup .discussion .mini-discussion textarea {
    padding: 10px;
    background: #ffffff;
    border: 1px solid #f8f8f8;
    border-radius: 8px;
    font-weight: 500;
    font-size: 15px;
    width: 100%;
    text-indent: 40px;
    outline: 0;
}

.mygroup .discussion .mini-discussion textarea::placeholder {
    color: #bbbbbb;
}

.mygroup .discussion .mini-discussion img {
    position: absolute;
    left: 7px;
    top: 7px;
    border-radius: 4px;
    width: 32px;
    height: 32px;
    object-fit: cover;
}

.mygroup .discussion .mini-discussion .att-btn {
    margin: 0;
    padding: 5px;
    position: absolute;
    right: 7px;
    top: 3px;
    border: none;
    border-radius: 4px;
    width: 32px;
    height: 32px;
    background: #f1eafe;
    color: #6c2fbb;
}

.mygroup .discussion .mini-discussion .profile-image {
    position: absolute;
    left: 7px;
    top: 7px;
    border-radius: 4px;
    width: 32px;
    height: 32px;
    font-size: 15px;
}

.attachments .attachments-item {
    width: auto !important;
}

/* .mygroup .discussion .mini-discussion p {
    font-weight: 500;
    font-size: 15px;
    color: #383144;
    margin-bottom: 0;
} */

.mygroup .discussion .db-btn {
    background: #6c2fbb;
    border-radius: 8px;
    outline: none;
    border: none;
    max-width: 120px;
    width: 100%;
    height: 48px;
    color: #ffffff;
}

.comment-video {
    cursor: pointer;
    display: inline-block;
    height: 60px;
    position: relative;
}

.comment-video .playicon {
    color: #6c2fbb;
    border-radius: 50%;
    font-size: 24px;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
}

.comment-video img {
    width: auto;
    height: inherit;
}

.mygroup .dis-middle .data-list .weekend {
    display: flex;
    gap: 8px;
    padding: 10px;
    margin: 8px 2px;
    /*margin-bottom: 18px;*/
}

/* .weekend{
    width: fit-content;
} */

.mygroup .dis-middle .data-list .weekend:hover {
    /* background-color: #fafafa; */
    box-shadow: 0 0 2px 0 rgb(0 0 0 / 50%);
}

/*.mygroup .dis-middle .data-list .weekend img {*/
/*    border-radius: 4px;*/
/*    width: 32px;*/
/*    height: 32px;*/
/*    object-fit: cover;*/
/*    position: absolute;*/
/*}*/

.mygroup .dis-middle .data-list .weekend .profile-image {
    border-radius: 4px;
    width: 32px;
    height: 32px;
    position: absolute;
    /* object-fit: contain; */
    object-fit: cover;
    font-size: 15px;
    cursor: pointer;
}

.mygroup .dis-middle .data-list .weekend .ago {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
}

.mygroup .dis-middle .data-list .weekend .ago h6 {
    cursor: pointer;
    font-weight: 500;
    font-size: 15px;
    color: #0f062b;
    margin-bottom: 0;
    margin-right: 4px;
    white-space: nowrap;
}

.mygroup .dis-middle .data-list .weekend .ago span.span {
    font-weight: 900;
    font-size: 15px;
    color: #0f062b;
    margin: 0 5px;
}

.mygroup .dis-middle .data-list .weekend .ago span {
    font-weight: 500;
    font-size: 12px;
    color: #878395;
}

.mygroup .dis-middle .data-list .weekend .meni {
    width: 100%;
    margin-left: 40px;
}

.mygroup .dis-middle .data-list .weekend .meni .comment-text {
    margin-bottom: 0;
    font-weight: 400;
    font-size: 15px;
    /*color: #878395;*/
}

.mygroup .dis-middle .data-list .weekend .meni .lier {
    display: flex;
    align-items: center;
    /* width: 400px; */
}

.mygroup .dis-middle .data-list .weekend .meni .lier .sub {
    display: flex;
    align-items: center;
    gap: 8px;
}

.mygroup .dis-middle .data-list .weekend .meni .lier .sub-2 {
    min-width: 150px;
    width: 100%;
}

.mygroup .dis-middle .data-list .weekend .meni .lier .sub-2 button,
.mygroup .dis-middle .data-list .weekend .meni .lier .sub button {
    border: 0;
    outline: 0;
    background-color: transparent;
    padding: 5px;
}

.mygroup .dis-middle .data-list .weekend .meni .lier .sub .zero {
    font-weight: 400;
    font-size: 13px;
    color: #0f062b;
    margin-bottom: 0;
}

.mygroup .dis-middle .data-list .weekend .meni .lier .sub-2 .zero {
    font-size: 14px;
    color: #007bff;
    font-weight: 500;
}

.mygroup .dis-middle .data-list .weekend .meni .lier .sub-2 .zero svg {
    margin-left: 5px;
    margin-bottom: 2px;
}

.mygroup .dis-middle .data-list .weekend:hover .meni .lier .sub-3 {
    display: flex;
}

.mygroup .dis-middle .data-list .weekend .meni .lier .sub-3 {
    display: none;
    align-items: center;
    gap: 8px;
}

.mygroup .dis-middle .data-list .weekend .meni .lier .sub-3 button {
    width: 59px;
    height: 30px;
    border-radius: 5px;
    font-weight: 400;
    font-size: 12px;
    color: #ffffff;
    border: 0;
    outline: 0;
}

.mygroup .dis-middle .data-list .weekend .meni .lier .sub-3 button.up {
    /* background-color: #ab5be9; */
    background-color: #6c2fbb;
}

.mygroup .dis-middle .data-list .weekend .meni .lier .sub-3 button.del {
    background-color: #c401ec;
}

.tabs {
    margin-top: 20px;
    border-top: 1px solid lightgray;
    display: flex;
    align-items: center;
    justify-content: center;
    -moz-column-gap: 30px;
         column-gap: 30px;
    padding: 10px 0;
}

.tabs button {
    background-color: transparent;
    color: gray;
    font-weight: 600;
    font-size: 20px;
    display: flex;
    align-items: center;
    -moz-column-gap: 2px;
         column-gap: 2px;
}

.tabs button.active {
    color: #6c2fbb;
    position: relative;
}

.tabs button.active::after {
    position: absolute;
    content: "";
    width: 100%;
    height: 2px;
    top: -11px;
    left: 0;
    background-color: #6c2fbb;
}

.activity-content,
.like-content,
.share-content {
    margin-top: 50px;
    padding: 0 100px;
    overflow: auto;
    /* display: none; */
}

.activity-content .two-btns,
.like-content .two-btns,
.share-content .two-btns {
    position: absolute;
    top: 12px;
    right: 25px;
    background-color: #000000a2;
    display: flex;
    align-items: center;
    -moz-column-gap: 10px;
         column-gap: 10px;
    padding: 2px 10px;
    border-radius: 10px;
}

.activity-content .two-btns button,
.like-content .two-btns button,
.share-content .two-btns button {
    background-color: transparent;
    display: flex;
    align-items: center;
    -moz-column-gap: 5px;
         column-gap: 5px;
}

.activity-content .two-btns button img,
.like-content .two-btns button img,
.share-content .two-btns button img {
    width: 13px;
}

.arrow {
    width: 23px !important;
}

.activity-content .two-btns button span,
.like-content .two-btns button span,
.share-content .two-btns button span {
    color: #fff;
    font-size: 17px !important;
}

.activity-content p,
.like-content p,
.share-content p {
    margin-bottom: 0;
    margin-top: 5px;
}

.activity-content h5,
.like-content h5,
.share-content h5 {
    color: #0f062b;
    font-weight: 800 !important;
    font-size: 25px;
    margin-bottom: 0;
}

.activity-content span,
.like-content span,
.share-content span {
    font-size: 22px !important;
    font-weight: 600;
}

.activity-content span:last-child,
.like-content span:last-child,
.share-content span:last-child {
    color: #6c2fbb;
}

.activity-content p,
.like-content p,
.share-content p {
    color: #878395;
}

#display {
    display: block;
}

::ng-deep .NgxEditor__Content {
    height: 85px;
    overflow: auto;
    text-align: left;
}


::ng-deep span.spanComment p {
    /* display: flex; */
    /* flex-direction: column; */
}


::ng-deep span.spanComment p a.highlight{
    background: #f1eafe;
    color: #6c2fbb;
}
::ng-deep span.replyComment p a.highlight{
    background: #f1eafe;
    color: #6c2fbb;
}
::ng-deep span.replyComment p a{
    background: #f1eafe;
    color: #6c2fbb;
}
::ng-deep span.spanComment p a{
    background: #f1eafe;
    color: #6c2fbb;
}
::ng-deep .ProseMirror.NgxEditor__Content p a{
    background: #f1eafe;
    color: #6c2fbb;
}

/* ::ng-deep span.spanComment p a{
    background: #f1eafe;
    color: #6c2fbb;
} */

::ng-deep #update_comment .NgxEditor__Content {
    height: auto;
    overflow: auto;
    text-align: left;
}

::ng-deep #update_comment .NgxEditor__MenuBar {
    flex-wrap: nowrap !important;
    padding: 3px 0 !important;
}

::ng-deep .NgxEditor__Wrapper {
    border-radius: 0 !important;
}

::ng-deep .NgxEditor__Popup .NgxEditor__Popup--FormGroup label {
    margin-bottom: 3px;
    text-align: left;
}


::ng-deep #update_comment span.NgxEditor__ImageWrapper {
    width: -moz-fit-content !important;
    width: fit-content !important;
}


::ng-deep .NgxEditor__Dropdown--DropdownMenu {
    text-align: left;
}

::ng-deep .NgxEditor__Content p {
    margin: 0 !important;
}

::ng-deep .scrollable-menu {
    max-height: 200px !important;
}

::ng-deep ul.dropdown-menu.scrollable-menu.mention-menu li a p {
    margin: 0;
    padding: 3px 0;
    font-size: 15px;
    display: flex;
    gap: 5px;
    align-items: center;
}

::ng-deep ul.dropdown-menu.scrollable-menu.mention-menu li a p span.vl {
    border-left: 1px solid #cccccc;
    height: 20px;
    display: block;
}

::ng-deep ul.dropdown-menu.scrollable-menu.mention-menu li a p span.fullname {
    color: #8e8e8e;
}

::ng-deep .mention-active>a {
    background-color: #6c2fbb !important;
}

.tagUserModal {
    position: absolute;
    background-color: #f3f3f3;
    height: 250px;
    overflow: auto;
    z-index: 1;
    /* top: -14px; */
    border: 1px solid #cccccc;
    padding: 0 5px 10px;
    width: -moz-max-content;
    width: 100%;
    border-radius: 5px;
    left: 0;
    bottom: -17px;
}

#offcanvasRight .tagUserModal {
    position: absolute;
    background-color: #f3f3f3;
    height: 250px;
    overflow: auto;
    z-index: 1;
    border: 1px solid #cccccc;
    padding: 0 5px 10px;
    border-radius: 5px;
    bottom: 237px;
    width: 100%;
    margin-left: 17px;
    max-width: 582px;
}

#offcanvasRight #update_comment_reply .tagUserModal {
    position: absolute;
    background-color: #f3f3f3;
    height: 250px;
    overflow: auto;
    z-index: 1;
    border: 1px solid #cccccc;
    padding: 0 5px 10px;
    border-radius: 5px;
    bottom: 123px;
    width: 100%;
    margin-left: 0;
    max-width: 582px;
}

#offcanvasRight .reply {
    /* position: fixed !important; */
    /* bottom: 70px; */
    /* left: 0; */
    /* right: -7px; */
    width: 100%;
}
#offcanvasRight .demo {
    height: calc(100vh - 345px);
    overflow: auto;
}

#update_comment .tagUserModal {
    position: absolute;
    background-color: #f3f3f3;
    height: 235px;
    overflow: auto;
    z-index: 1;
    border: 1px solid #cccccc;
    padding: 0 5px 10px;
    width: 100%;
    border-radius: 5px;
    bottom: 100%;
    left: 0;
}
@media only screen and (max-width: 767px) and (min-width: 200px) {
    #update_comment .tagUserModal {
        width: 84%;
        bottom: 236px;
    }
}

.vl {
    border-left: 1px solid #cccccc;
    height: 20px;
    display: block;
}

.tagUserModal p span {
    display: block;
}

.tagUserModal p {
    padding: 4px 8px;
}

span.fullname {
    color: #8e8e8e;
}

/* .tagUserModal p:hover {
    background-color: #f1eafe !important;
    color: #6c38bf;
    border-radius: 4px;
    cursor: pointer;
} */

.tagUserModal p:hover span.fullname {
    color: white;
}

.highlighted {
    background-color: #f1eafe !important;
    color: #6c38bf;
    border-radius: 4px;
    cursor: pointer;
}

.tagUserModal p span img {
    position: unset !important;
}

.tagUserModal p span.profile-image {
    position: relative !important;
    left: 0 !important;
    line-height: 2.3;
    font-size: 13px !important;
    top: 0 !important;
    width: 28px !important;
    height: 28px !important;
}

.tagUserModal p span.username {
    font-size: 15px;
    font-weight: 500;
}

.tagUserModal input {
    font-size: 15px;
    font-weight: 500;
}

.tagUserModal .stickyClass {
    position: sticky;
    top: 0;
    z-index: 1;
    background-color: #f3f3f3;
    padding: 10px 0 2px 0;
}
.left-arrow,
.right-arrow {
    background-color: #ededed;
    height: 20px;
    width: 20px;
    line-height: 18px;
    text-align: center;
    cursor: pointer;
    flex-shrink: 0;
    border-radius: 9px;
}

.left-arrow svg,
.right-arrow svg {
    width: 10px;
    height: 10px;
}

/* =================================== */
.offcanvas-header {
    border-bottom: 1px solid #d2d2d2;
}

.mytextdiv {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 5px;
}

.mytexttitle {
    flex-grow: 0;
    font-size: 15px;
    color: gray;
}

.divider {
    flex-grow: 1;
    height: 1px;
    background-color: #e0dede;
}

.offcanvas-end {
    width: 600px;
}

.lastReply {
    color: gray;
    font-size: 14px;
    font-weight: 500;
}

.zero:hover {
    text-decoration: underline;
}

/* =================================== */


.memberCommunity {
    font-size: 15px;
    font-weight: 500;
    color: #6c757d;
}

.memberCommunity span {
    color: #6c2fbb;
    text-decoration: underline;
    cursor: pointer;
}

.pinnedMessages{
    color: #6c2fbb;
}

hr{
    border-color: #777777;
    border-width: thin;
    margin: 4px 0 0 0;
}

::ng-deep .cdk-overlay-pane.analytics-modal {
    background: #f8fafb;
    margin-block: 30px !important;
    position: relative !important;
    height: calc(100vh - 50px) !important;
}

@media (max-width: 1300px) {
    .mygroup .admin-area .activeted {
        gap: 10px;
    }

    /*.mygroup .admin-area .activeted .active-imger {*/
    /*    width: 50px;*/
    /*    height: 51px;*/
    /*    min-width: 50px;*/
    /*}*/
    .mygroup .admin-area .activeted .active-imger.active::after {
        top: -4px;
        right: -4px;
        width: 13px;
        height: 13px;
    }

}

@media (max-width: 1200px) {

    .activity-content,
    .like-content,
    .share-content {
        padding: 0 15px;
    }
}

@media (max-width: 1199px) {
    .admin-area .border-group >div:first-child >div {
        width: auto;
    }
    .show-admin {
        display: flex;
        flex-wrap: wrap;
    }
}
@media (max-width: 991px) {
    .tab-box-video ul li .edit-tab svg,
    .tab-box-video ul li .delete-tab ,
     .tab-box-video ul li .pinImage {
        display: inline-block !important;
    }
    .content-area .img-box {
        height: 205px;
    }

    .activity-content,
    .like-content,
    .share-content {
        padding: 0 100px;
    }

    .activity-content h5,
    .like-content h5,
    .share-content h5 {
        margin-top: 20px;
    }

    /*.mygroup .title-img-area .nature-text .nature-sub{*/
    /*    padding-left: 0;*/
    /*}*/
}

@media (max-width: 768px) {
    .content-area .img-box {
        height: 241px;
    }

    .image-button-box {
        flex-wrap: wrap;
        justify-content: start;
    }
    .tab-box-video {
        align-items: baseline !important;
    }
    .tab-box-video ul {
        margin-inline: 10px;
    }
    .right-arrow {
        display: block;
    }
}

@media (max-width: 600px) {

    .activity-content,
    .like-content,
    .share-content {
        padding: 0 15px;
    }
}

@media (max-width: 575px) {
    .view-all {
        padding-top: 10px;
    }

    .mobile-view {
        flex-direction: column;
    }

    .mobile-view .nature-sub {
        padding-left: 0 !important;
    }
    .admin-area >div {
        justify-content: flex-start !important;
    }
    .mygroup .content-page {
        padding-inline: 20px;
    }
}

@media (max-width: 475px) {
    .mygroup .dis-middle .data-list .weekend .meni .lier {
        flex-wrap: wrap;
    }

    .mygroup .dis-middle .data-list .weekend .meni .lier .sub-3 {
        width: 100%;
        margin-top: 8px;
    }

    .mygroup .dis-middle .data-list .weekend .meni .lier .sub-2.mr-3 {
        margin-right: 0 !important;
    }

    .mygroup .dis-middle .data-list .weekend {
        margin-bottom: 25px;
    }

    .view-all {
        padding-top: 5px;
    }
}

@media (max-width: 425px) {

    .mygroup .admin-area .activeted .active-imger.active::after {
        top: -3px;
        right: -2px;
        width: 10px;
        height: 10px;
    }

    .btn-custom .group {
        font-size: 14px;
        height: 40px;
    }

    .mygroup .content-page .content-area h4 {
        font-size: 19px;
        margin-top: 10px;
    }

    .content-area .img-box {
        height: 222px;
    }

    .mygroup .admin-area h2 {
        font-size: 20px;
        margin-bottom: 0;
    }

    .mygroup .admin-area .add-title {
        font-size: 20px;
        margin-bottom: 0;
    }

    .mygroup .discussion {
        flex-wrap: wrap;
    }

    .mygroup .discussion button {
        height: 40px;
        max-width: none;
    }

    .mygroup .dis-middle .group-comp button {
        height: 40px;
    }

    .mygroup .title-img-area .nature-text .nature-sub h5 {
        font-size: 25px;
    }

    .mygroup .title-img-area .nature-text .nature-sub .group-title {
        font-size: 20px;
    }

    .mygroup .discussion .mini-discussion input {
        height: 40px;
        text-indent: 31px;
    }

    .mygroup .discussion .mini-discussion img {
        left: 6px;
        top: 6px;
        width: 28px;
        height: 28px;
    }

    .activity-content,
    .like-content,
    .share-content {
        margin-top: 20px;
    }

    .mygroup .title-img-area .nature-div {
        min-width: 100%;
    }
}

@media (max-width: 320px) {
    .btn-custom .group {
        width: 146px;
    }

    .mygroup .admin-area .activeted .active-imger {
        width: 40px;
        min-width: 40px;
        height: 41px;
    }

    .mygroup .admin-area .activeted h6 {
        font-size: 17px;
    }

    .mygroup .admin-area .activeted p {
        font-size: 14px;
    }

    .activity-content h5,
    .like-content h5,
    .share-content h5 {
        font-size: 20px;
    }
}

.see-all {
    position: absolute;
    right: 22px;
    top: 3px;
    color: white;
    cursor: pointer;
}

.c-cmt {
    color: #6c2fbb;
    cursor: pointer;
}

.rotate-180 {
    /* IE 9 */
    transform: rotate(180deg);
}

.reply-input {
    /* border-left: 0;
    border-right: 0;
    border-top: 0;
    border-bottom: 0.12rem solid #80808030;
    outline: none; */
}

.reply-btn {
    border: none;
    background: #6c2fbb;
    color: white;
    padding: 2px 11px;
    border-radius: 4px;
    font-size: 15px;
}

.pro-img {
    width: 50px;
    height: 50px;
    border-radius: 10px;
    /*border-radius: 50%;*/
    /* border: 1px solid gainsboro; */
}

#add_member .profile-image {
    width: 50px;
    min-width: 50px;
    height: 50px;
    font-size: 22px;
    line-height: 30px;
    border-radius: 10px;
}

.profile-image {
    width: 50px;
    height: 50px;
    font-size: 20px;
    border-radius: 9px;
    /*    position: absolute;*/
    /*    left: 8px;*/
    /*    object-fit: cover;*/
    /*    width: 27px;*/
    /*    height: 27px;*/
    /*    border-radius: 50%;*/
    /*    border: 1px solid rgb(206 201 201);*/
    /*    background: none;*/
}

.input-search {
    position: relative;
}

.input-search-admin {
    padding-left: 28px;
    position: relative;
}

.input-searchs {
    padding-left: 32px;
}

.fa-search {
    position: absolute;
    top: 10px;
    left: 23px;
    z-index: 1;
    color: #495057a3;
}

select:not(.admin-select) {
    border: none;
    background: no-repeat;
    position: relative;
    top: -5px;
    color: rgb(0, 0, 0);
}

.memmber-list {
    color: rgb(0, 0, 0);
    /* margin-right: -31px;
    margin-left: -31px; */
    padding: 7px 0px;
    cursor: pointer;
    height: 300;
    overflow-x: hidden;
}

.m-list1 {
    /*background-color: #6c2fbb !important;*/
    background-color: #f2f2f2 !important;
    color: rgb(0, 0, 0);
}

.m-list2 {
    /*background-color: #6c2fbb !important;*/
    background-color: #f2f2f2 !important;
    /*color: rgb(243, 243, 243);*/
    color: rgb(0, 0, 0);
    padding: 7px 0px;
}

.lecture-name {
    margin-bottom: 0rem;
}

.select-first {
    color: rgb(0, 0, 0);
}

.select-first option {
    color: rgb(0, 0, 0);
}

.afterselect {
    color: white;
}

.member-view:hover {
    text-decoration: underline;
}

.private-view:hover {
    text-decoration: underline;
}

#upload-photo {
    opacity: 0;
    position: absolute;
    z-index: -1;
}

.save-btn {
    text-align: center;
    border: none;
    outline: none;
    background: none;
    background: #6c2fbb;
    /*opacity: 0.8;*/
    color: white;
    font-size: 15px;
    padding: 6px 31px;
    border-radius: 5px;
}

.video-views {
    height: 300px;
    overflow-y: scroll;
    overflow-x: hidden;
}

table {
    margin-bottom: 18px;
    border-collapse: collapse;
    border-spacing: 0;
    width: 100%;
    /* border: 1px solid #ddd; */
}

th,
td,
th {
    text-align: left;
    padding: 7px;
    font-size: 14px;
}

/* tr:nth-child(even) {
    background-color: #f2f2f2;
} */

#table_header {
    background: #8600ff;
    color: white;
    font-size: 14px;
    height: 53px !important;
    box-shadow: 0px 0px 5px 0px rgb(0 0 0 / 20%);
}

.table-view {
    height: 276px;
    overflow: scroll;
    margin-bottom: 24px;
    /* border: 1px solid #80808029; */
}

#view_member .profile-image {
    width: 50px;
    min-width: 50px;
    height: 50px;
    font-size: 22px;
    line-height: 30px;
    border-radius: 10px;
    /*margin-right: 0;*/
    /*margin-right: 0;*/
}

.member-admin-profile {
    height: 50px;
    width: 50px;
    object-fit: cover;
    /* object-fit: contain; */
    /*border-radius: 50%;*/
    border-radius: 10px;
    /*border: 2px solid white !important;*/
}

.dropdown-menu {
    z-index: 1;
}

.dropdown-item {
    border-bottom: 0;
    padding: 3px 10px;
    /*padding: 0;*/
}

.dropdown-item:hover {
    background-color: #f2f2f2;
    color: black;
}

/*.drop-menus {*/
/*    transform: translate3d(-82px, -3px, 0px) !important;*/
/*    min-width: 83px !important;*/
/*}*/

.select-drop {
    font-size: 13px;
    padding: 0;
    border: 1px solid #8080802b;
    height: 23px !important;
    margin-top: 8px;
}

.privacy-text {
    position: absolute;
    left: 0;
    top: 19px;
}

.custom-control {
    position: relative !important;
    top: -25px;
}

.update-btn {
    border: none;
    background: #8600ff;
    border-radius: 5px;
    color: white;
    padding: 4px 30px;
}

.FF-scroll-modify {
    display: none;
    height: 100% !important;
    max-height: 625px;
    scroll-behavior: smooth;
    touch-action: auto;
}

.more-images {
    background: #F5F5F5 !important;
    border: 1px solid #727272 !important;
    color: #727272;
}

.group-list-new {
    background: #FFFFFF;
    padding: 15px 20px;
    border: 1px solid #F8F8F8;
    border-radius: 16px;
}

.group-list-img {
    object-fit: contain;
    width: 70px !important;
    height: 70px;
    margin: 0 auto;

    /*box-shadow: 0px 0px 2px 0px rgb(0 0 0 / 50%) !important*/
}

.owl-carousel-two .img-box:hover {
    border-radius: 9px;
}

.owl-carousel-two .img-box-create {
    box-shadow: 0px 0px 2px 0px rgb(0 0 0 / 50%) !important;
    margin: 2px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    width: 68px;
    height: 68px;
    color: #6c2fbb;
}

.owl-carousel-two .img-box {
    overflow: hidden;
    border-radius: 50px;
    transition: 0.5s;
    cursor: pointer;
    /*position: relative;*/
    margin: 1px 1px 16px;
}

/* 
.owl-carousel-two .img-box.active:after {
    content: "";
    position: absolute;
    height: 100%;
    width: 100%;
    bottom: 0;
    right: auto;
    left: auto;
    background-image: radial-gradient(circle at center, #6c2fbb 4px, transparent 5px);
    background-size: 15px 15px;
    background-position: bottom center;
    background-repeat: no-repeat;
} */

.activeClass span {
    background: #6c2fbb;
    height: 8px;
    width: 8px;
    border-radius: 100%;
    display: block;
}

.owl-carousel-two .img-box.premium {
    box-shadow: 0 0 2px 1px #6c2fbb !important;
    width: auto;
    margin-right: 10px;
}

.owl-carousel-two {
    max-width: 95%;
    margin: 0 auto;
}

.replysection:hover .replyDelete {
    display: flex;
    justify-content: end;
    padding-right: 15px;
    gap: 5px;
}

.replyDelete {
    display: none;
    text-align: center;
}

.replyDelete button {
    background-color: #c401ec;
    width: 59px;
    height: 30px;
    border-radius: 5px;
    font-weight: 400;
    font-size: 12px;
    color: #ffffff;
    border: 0;
}
.replyDelete button.up {
    background-color: #6c2fbb;
}

@media (max-width: 1024px) {
    .owl-carousel-two {
        max-width: 86%;
    }
}

@media (max-width: 512px) {

    .group-list-img,
    .img-box-create {
        width: 60px !important;
        height: 60px !important;
    }
}

.planBadge {
    cursor: pointer;
    display: inline-block;
    overflow: hidden;
    background: #e1e1f9;
    border-radius: 20px;
    border: none;
    outline: none;
    color: #6438b4;
    padding: 5px 15px;
    margin-top: 10px;
    font-weight: bold;
    font-size: 14px;
}

.btn-show-password {
    position: absolute;
    right: 0;
    top: 0;
}


/*tab boxed*/


.tab-box-video {
    display: flex;
    justify-content: center;
    align-items: center;
}

.tab-box-video ul {
    display: flex;
    align-items: center;
    white-space: nowrap;
    overflow: auto;
    width: 100%;
    margin:0;
    scrollbar-width: none;
    /* justify-content: center; */
}

.tab-box-video ul li {
    position: relative;
    list-style: none;
    /* font-weight: 500; */
    font-size: 18px;
    padding: 5px 10px 0 10px;
    margin: 0 15px;
    color: #878395;
    cursor: pointer;
}

.tab-box-video ul li svg {
    fill: #878395;
}

.tab-box-video ul li.active {
    border-top: 3px solid #6c2fbb;
    color: #6c2fbb;
}

.tab-box-video ul li.active svg {
    fill: rgba(108, 47, 187, 1);
}

.tab-box-video ul li .add-tab {
    color: #6c2fbb;
    background: #e1e1f9;
    height: 30px;
    width: 30px;
    display: flex;
    justify-content: center;
    align-items: center;
}

.tab-box-video ul li .delete-tab {
    position: absolute;
    right: -10px;
    display: none;
    color: #dc3545;
    top: 6px;
}

.tab-box-video ul li .edit-tab svg {
    height: 16px;
    width: 16px;
    fill: black;
    margin-left: 3px;
    display: none;
}

.pinImage{
    display: none;
}

.tab-box-video ul li:hover .delete-tab {
    display: inline-block;
}

.tab-box-video ul li:hover .edit-tab svg {
    display: inline-block;
}
.tab-box-video ul li:hover .pinImage {
    display: inline-block;
    position: unset;
}

.isPinned{
    background-color: #f1eafe8c;
    border: 1px solid #ae88df;
    border-radius: 4px;
}

.discussionBoard h2 {
    width: 100%;
    max-width: -moz-fit-content;
    max-width: fit-content;
}

.discussionBoard .tab-box-video ul li .delete-tab {
    display: none;
    color: #dc3545;
    position: unset;
    padding: 0 5px 0 5px;
}

.discussionBoard .tab-box-video ul li:hover .delete-tab {
    display: inline-block;
}
.customMenu h6 {
    font-size: 18px;
}

::ng-deep .tooltip001 {
    position: absolute;
    background-color: white;
    border: 1px solid #ccc;
    padding: 10px 13px;
    box-shadow: 0 2px 5px rgba(0,0,0,0.1);
    z-index: 1000; 
}
::ng-deep .tooltip001 span {
   display: flex;
   align-items: center;
   gap: 10px;
}
::ng-deep .tooltip001 img {
    width: 50px;
    height: 50px;
    border-radius: 5px;
}
::ng-deep .tooltip001 .profile-image {
    width: 50px;
    height: 50px;
    border-radius: 5px;
    font-size: 18px;
}
::ng-deep .modal-backdrop.fade:not(.show) {
    display: none;
}

.tab-box-video ul::-webkit-scrollbar {
    height: 4px;
}

.recorder-playlist {
    position: unset;
    display: inline-flex;
}
.recorder-playlist .btn-sm {
    background-color: #e1e1f9;
    padding: 0;
    width: 25px;
    height: 25px;
    margin-right: 4px;
}
.recorder-playlist span,
.recorder-playlist .btn-sm i {
    color: #6c2fbb;
}
.action-tab {
    width: 30px;
    height: 30px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 6px;
    background: #ffffff;
    color: #000000;
    border: 1px solid #cdcdcd;
    font-size: 14px;
    cursor: pointer;
}
.action-tab svg {
    fill: #000000;
}
.action-tab:hover {
    border-color: #6c2fbb;
    background: #f1eafe;
    color: #6c2fbb;
}
.action-tab:hover svg {
    fill: #6c2fbb;
}

@media (max-width: 1400px) {
    .tab-box-video ul li {
        font-size: 18px;
        white-space: nowrap;
    }
    .lastReply {
        white-space: nowrap;
    }

}

@media (max-width: 1200px) {
    .tab-box-video ul {
        overflow-x: auto;
        padding-bottom: 10px;

    }

    
}

@media (max-width: 768px) {
    .tab-box-video ul {
        justify-content: start;
    }

    .tab-box-video ul li {
        font-size: 17px;
    }
}
@media (max-width: 767px) {
    #offcanvasRight .reply {
        width: 97%;
    }
} 
@media (max-width: 575px) {
    .memmber-list {
        flex-wrap: nowrap;
        gap: 10px;
    }
    .memmber-list .member-check {
        padding: 0;
    }
    .memmber-list .member-img {
        padding: 0;
    }
} 
@media (max-width: 480px) {
    ::ng-deep ngx-link.NgxEditor__MenuItem .NgxEditor__Popup {
        right: 0;
    }
    #offcanvasRight .demo {
        height: calc(100vh - 372px);
    }
    .btn-invite {
        margin-top: 0;
        margin-bottom: 10px;
    }
    .btn-invite span {
        white-space: nowrap;
    }
}
@media (max-width: 430px) {
    ::ng-deep ngx-image.NgxEditor__MenuItem .NgxEditor__Popup {
        left: 0;
    }
}
@media (max-width: 385px) {
    ::ng-deep ngx-link.NgxEditor__MenuItem .NgxEditor__Popup {
        left: 0;
    }
}
@media (min-width: 1400px) {
    .col-xxl-10 {
        flex: 0 0 auto;
        max-width: 83.33333333%;
    }
}`, "",{"version":3,"sources":["webpack://./src/app/afterLogin/group/new-my-group/new-my-group.component.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,gBAAgB;IAChB,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,uBAAuB;IACvB,oBAAoB;IACpB,2BAA2B;IAC3B,eAAe;IACf,cAAc;AAClB;;;AAGA;IACI,oBAAoB;IACpB,sBAAsB;IACtB,kBAAkB;AACtB;;AAEA;IACI,eAAe;AACnB;;AAEA;;IAEI,SAAS;IACT,UAAU;IACV,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;IAClB,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,cAAc;IACd,cAAc;AAClB;;AAEA,kBAAkB;AAClB,yCAAyC;AACzC,wBAAwB;AACxB,uBAAuB;AACvB,0BAA0B;AAC1B,0BAA0B;AAC1B,iCAAiC;AACjC,qBAAqB;AACrB,0BAA0B;AAC1B,IAAI;;AAEJ;IACI,yBAAyB;IACzB,iBAAiB;IACjB,eAAe;IACf,qBAAqB;IACrB,WAAW;IACX,yBAAyB;IACzB,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,eAAe;IACf,eAAe;IACf,uBAAkB;IAAlB,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,aAAa;IACb,uBAAuB;IACvB,aAAa;IACb,gBAAgB;IAChB,gBAAgB;IAChB,WAAW;IACX,mBAAmB;IACnB,gBAAgB;IAChB,kBAAkB;IAClB,yBAAyB;AAC7B;;AAEA;IACI,iBAAiB;IACjB,QAAQ;IACR,iBAAiB;IACjB,kBAAkB;IAClB,UAAU;IACV,WAAW;IACX,WAAW;IACX,YAAY;IACZ,uBAAuB;IACvB,kBAAkB;IAClB,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,WAAW;IACX,iBAAiB;IACjB,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,UAAU;IACV,WAAW;IACX,mBAAmB;IACnB,cAAc;IACd,uBAAuB;AAC3B;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,QAAQ;AACZ;;AAEA;IACI,kBAAkB;IAClB,wCAAwC;IACxC,oBAAoB;IACpB,sBAAsB;IACtB,0BAA0B;IAC1B,6BAA6B;IAC7B,kCAAkC;IAClC,qBAAqB;AACzB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,sBAAsB;IACtB,aAAa;IACb,sBAAsB;IACtB,8BAA8B;IAC9B,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,kBAAkB;IAClB,SAAS;AACb;;AAEA;IACI,cAAc;IACd,eAAe;IACf,uBAAuB;IACvB,kBAAkB;IAClB,SAAS;IACT,UAAU;IACV,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,gBAAgB;IAChB,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,gBAAgB;IAChB,aAAa;IACb,qBAAqB;IACrB,4BAA4B;IAC5B,gBAAgB;IAChB,uBAAuB;IACvB,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,oBAAoB;IACpB,sBAAsB;IACtB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,oBAAoB;IACpB,sBAAsB;IACtB,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;IACzB,uBAAuB;IACvB,kBAAkB;IAClB,gBAAgB;IAChB,qBAAqB;IACrB,qBAAqB;IACrB,gBAAgB;IAChB,kBAAkB;IAClB,sBAAsB;IACtB,iIAAiI;AACrI;;AAEA;IACI,WAAW;IACX,yBAAyB;AAC7B;;AAEA;IACI,cAAc;IACd,sBAAsB;IACtB,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,cAAc;IACd,oBAAoB;IACpB,UAAU;IACV,mBAAmB;IACnB,YAAY;IACZ,kBAAkB;IAClB,WAAW;IACX,YAAY;AAChB;AACA;IACI,eAAe;IACf,iBAAiB;IACjB,YAAY;AAChB;AACA;IACI,eAAe;AACnB;AACA;IACI,mBAAmB;AACvB;AACA;IACI,uBAAuB;IACvB,aAAa;IACb,YAAY;IACZ,cAAc;IACd,gBAAgB;IAChB,iBAAiB;IACjB,wBAAwB;IACxB,uBAAuB;AAC3B;;AAEA;IACI,mBAAmB;IACnB,yBAAyB;IACzB,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,oBAAoB;IACpB,kCAAkC;IAClC,SAAS;AACb;AACA;IACI,mBAAmB;AACvB;AACA;IACI,iBAAiB;AACrB;;AAEA;IACI,YAAY;IACZ,gBAAgB;IAChB,eAAe;IACf,cAAc;IACd,qBAAqB;IACrB,6BAA6B;AACjC;;AAEA;IACI,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,mBAAmB;IACnB,SAAS;IACT,eAAe;AACnB;AACA;IACI,kBAAkB;IAClB,uBAAkB;IAAlB,kBAAkB;IAClB,mBAAmB;AACvB;AACA;IACI,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,WAAW;IACX,kBAAkB;AACtB;AACA;IACI,eAAe;IACf,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,6CAA6C;AACjD;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,wBAAwB;IACxB,QAAQ;IACR,qBAAqB;AACzB;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,kBAAkB;IAClB,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,yBAAyB;IACzB,mBAAmB;IACnB,4BAA4B;AAChC;;AAEA;IACI,sBAAsB;IACtB,eAAe;IACf,eAAe;IACf,iBAAiB;IACjB,yBAAyB;AAC7B;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,8BAA8B;AAClC;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,WAAW;IACX,iBAAiB;IACjB,iBAAiB;IACjB,mBAAmB;IACnB,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,kBAAkB;IAClB,uBAAuB;AAC3B;;;;AAIA;IACI,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,YAAY;IACZ,eAAe;IACf,sBAAsB;IACtB,gBAAgB;IAChB,cAAc;IACd,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,sDAAsD;AAC1D;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,6BAA6B;IAC7B,0BAA0B;IAC1B,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,8BAA8B;IAC9B,sBAAsB;IACtB,YAAY;IACZ,iBAAiB;IACjB,eAAe;IACf,cAAc;AAClB;;AAEA;;IAEI,aAAa;IACb,6BAA6B;IAC7B,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,8BAA8B;IAC9B,sBAAsB;IACtB,YAAY;IACZ,iBAAiB;IACjB,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,gBAAgB;IAChB,uBAAuB;IACvB,iBAAiB;IACjB,sDAAsD;AAC1D;;AAEA;;IAEI,gBAAgB;IAChB,uBAAuB;IACvB,gBAAgB;IAChB,sDAAsD;AAC1D;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,aAAa;IACb,uBAAuB;IACvB,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,mBAAmB;AACvB;AACA;IACI,uBAAuB;AAC3B;AACA;IACI;AACJ;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,mBAAmB;IACnB,6BAA6B;IAC7B,6BAA6B;IAC7B,qCAAqC;AACzC;AACA;IACI,gBAAgB;AACpB;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI;QACI,aAAa;IACjB;;IAEA;QACI,qBAAqB;IACzB;AACJ;;AAEA;IACI;QACI,aAAa;IACjB;AACJ;;AAEA;IACI;QACI,aAAa;IACjB;AACJ;;;AAGA;IACI;QACI,gBAAgB;;IAEpB;AACJ;AACA;IACI;QACI,yBAAyB;IAC7B;AACJ;;;AAGA;IACI,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,+BAA+B;IAC/B,2BAA2B;IAC3B,aAAa;IACb,eAAe;IACf,mBAAmB;IACnB,qBAAgB;SAAhB,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,yBAAyB;IACzB,SAAS;IACT,WAAW;AACf;;AAEA;IACI,+CAA+C;IAC/C,kBAAkB;IAClB,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,yBAAyB;IACzB,kBAAkB;IAClB,6BAA6B;IAC7B,WAAW;IACX,YAAY;IAEZ,WAAW;IACX,kCAAkC;AACtC;;AAEA;;IAEI,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,cAAc;IACd,yBAAyB;IACzB,mBAAmB;IACnB,gBAAgB;IAChB,uBAAkB;IAAlB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,qBAAqB;IACrB,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,wBAAwB;IACxB,UAAU;IACV,WAAW;IACX,kBAAkB;IAClB,qBAAqB;IACrB,yBAAyB;IACzB,gDAAgD;IAChD,kBAAkB;AACtB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,kBAAkB;IAClB,uBAAkB;IAAlB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,uBAAuB;IACvB,cAAc;IACd,UAAU;IACV,8BAA8B;IAC9B,YAAY;IACZ,WAAW;IACX,mBAAmB;IACnB,SAAS;IACT,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,qBAAqB;IACrB,uBAAuB;IACvB,sBAAsB;IACtB,2BAA2B;AAC/B;;AAEA;IACI,wBAAwB;IACxB,SAAS;IACT,aAAa;IACb,SAAS;IACT,WAAW;IACX,yBAAyB;IACzB,YAAY;IACZ,uBAAuB;IACvB;oCACgC;IAChC,8BAA8B;IAC9B,+BAA+B;IAC/B,gCAAgC;AACpC;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,mBAAmB;IACnB,6BAA6B;IAC7B,gBAAgB;IAChB,wBAAwB;IACxB,uBAAuB;IACvB,uBAAuB;AAC3B;AACA;IACI,mBAAmB;IACnB,6BAA6B;IAC7B,gBAAgB;IAChB,wBAAwB;IACxB,uBAAuB;IACvB,eAAe;IACf,YAAY;IACZ,uBAAuB;AAC3B;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,uBAAuB;IACvB,qBAAqB;IACrB,oBAAoB;AACxB;;;AAGA;IACI,oBAAoB;AACxB;AACA;IACI,6BAA6B;AACjC;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,wBAAwB;IACxB,uBAAuB;IACvB,6BAA6B;AACjC;;AAEA;IACI,wBAAwB;IACxB,uBAAuB;IACvB,6BAA6B;AACjC;;AAEA;IACI,gBAAgB;AACpB;;AAEA;;IAEI,yBAAyB;IACzB,WAAW;AACf;;;AAGA,WAAW;;AAWX;IACI;QACI,uBAAuB;IAC3B;;IAEA;QACI,yBAAyB;IAC7B;AACJ;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,mBAAmB;IACnB,kBAAkB;IAClB,cAAc;IACd,YAAY;IACZ,UAAU;AACd;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,WAAW;IACX,iBAAiB;IACjB,UAAU;AACd;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,QAAQ;IACR,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,SAAS;IACT,YAAY;IACZ,kBAAkB;IAClB,UAAU;IACV,QAAQ;IACR,YAAY;IACZ,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,QAAQ;IACR,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;;;;;GAKG;;AAEH;IACI,mBAAmB;IACnB,kBAAkB;IAClB,aAAa;IACb,YAAY;IACZ,gBAAgB;IAChB,WAAW;IACX,YAAY;IACZ,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,qBAAqB;IACrB,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,eAAe;IACf,kBAAkB;IAClB,SAAS;IACT,QAAQ;IAKR,gCAAgC;AACpC;;AAEA;IACI,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,QAAQ;IACR,aAAa;IACb,eAAe;IACf,uBAAuB;AAC3B;;AAEA;;GAEG;;AAEH;IACI,+BAA+B;IAC/B,sCAAsC;AAC1C;;AAEA,iDAAiD;AACjD,0BAA0B;AAC1B,mBAAmB;AACnB,oBAAoB;AACpB,yBAAyB;AACzB,0BAA0B;AAC1B,IAAI;;AAEJ;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,yBAAyB;IACzB,iBAAiB;IACjB,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,cAAc;IACd,aAAa;AACjB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,gBAAgB;IAChB,WAAW;AACf;;AAEA;;IAEI,SAAS;IACT,UAAU;IACV,6BAA6B;IAC7B,YAAY;AAChB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,cAAc;IACd,SAAS;IACT,UAAU;AACd;;AAEA;IACI,+BAA+B;IAC/B,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,gBAAgB;IAChB,+BAA+B;IAC/B,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,qBAAgB;SAAhB,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,6BAA6B;IAC7B,WAAW;IACX,gBAAgB;IAChB,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,oBAAe;SAAf,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,WAAW;IACX,WAAW;IACX,UAAU;IACV,OAAO;IACP,yBAAyB;AAC7B;;AAEA;;;IAGI,gBAAgB;IAChB,gBAAgB;IAChB,cAAc;IACd,mBAAmB;AACvB;;AAEA;;;IAGI,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,2BAA2B;IAC3B,aAAa;IACb,mBAAmB;IACnB,qBAAgB;SAAhB,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;;;IAGI,6BAA6B;IAC7B,aAAa;IACb,mBAAmB;IACnB,oBAAe;SAAf,eAAe;AACnB;;AAEA;;;IAGI,WAAW;AACf;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;;;IAGI,WAAW;IACX,0BAA0B;AAC9B;;AAEA;;;IAGI,gBAAgB;IAChB,eAAe;AACnB;;AAEA;;;IAGI,cAAc;IACd,2BAA2B;IAC3B,eAAe;IACf,gBAAgB;AACpB;;AAEA;;;IAGI,0BAA0B;IAC1B,gBAAgB;AACpB;;AAEA;;;IAGI,cAAc;AAClB;;AAEA;;;IAGI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,YAAY;IACZ,cAAc;IACd,gBAAgB;AACpB;;;AAGA;IACI,mBAAmB;IACnB,4BAA4B;AAChC;;;AAGA;IACI,mBAAmB;IACnB,cAAc;AAClB;AACA;IACI,mBAAmB;IACnB,cAAc;AAClB;AACA;IACI,mBAAmB;IACnB,cAAc;AAClB;AACA;IACI,mBAAmB;IACnB,cAAc;AAClB;AACA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;;;GAGG;;AAEH;IACI,YAAY;IACZ,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,4BAA4B;IAC5B,yBAAyB;AAC7B;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;AACpB;;;AAGA;IACI,kCAA6B;IAA7B,6BAA6B;AACjC;;;AAGA;IACI,gBAAgB;AACpB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,SAAS;IACT,cAAc;IACd,eAAe;IACf,aAAa;IACb,QAAQ;IACR,mBAAmB;AACvB;;AAEA;IACI,8BAA8B;IAC9B,YAAY;IACZ,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,kBAAkB;IAClB,yBAAyB;IACzB,aAAa;IACb,cAAc;IACd,UAAU;IACV,gBAAgB;IAChB,yBAAyB;IACzB,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,kBAAkB;IAClB,OAAO;IACP,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,yBAAyB;IACzB,aAAa;IACb,cAAc;IACd,UAAU;IACV,yBAAyB;IACzB,mBAAmB;IACnB,kBAAkB;IAClB,aAAa;IACb,WAAW;IACX,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,yBAAyB;IACzB,aAAa;IACb,cAAc;IACd,UAAU;IACV,yBAAyB;IACzB,mBAAmB;IACnB,kBAAkB;IAClB,aAAa;IACb,WAAW;IACX,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,gCAAgC;IAChC,kBAAkB;IAClB,aAAa;IACb,iBAAiB;IACjB,WAAW;AACf;AACA;IACI,2BAA2B;IAC3B,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,yBAAyB;IACzB,aAAa;IACb,cAAc;IACd,UAAU;IACV,yBAAyB;IACzB,mBAAmB;IACnB,WAAW;IACX,kBAAkB;IAClB,YAAY;IACZ,OAAO;AACX;AACA;IACI;QACI,UAAU;QACV,aAAa;IACjB;AACJ;;AAEA;IACI,8BAA8B;IAC9B,YAAY;IACZ,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,cAAc;AAClB;;AAEA;;;;;GAKG;;AAEH;IACI,YAAY;AAChB;;AAEA;IACI,oCAAoC;IACpC,cAAc;IACd,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,6BAA6B;IAC7B,kBAAkB;IAClB,gBAAgB;IAChB,0BAA0B;IAC1B,iBAAiB;IACjB,sBAAsB;IACtB,uBAAuB;AAC3B;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,MAAM;IACN,UAAU;IACV,yBAAyB;IACzB,qBAAqB;AACzB;AACA;;IAEI,yBAAyB;IACzB,YAAY;IACZ,WAAW;IACX,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,cAAc;IACd,kBAAkB;AACtB;;AAEA;;IAEI,WAAW;IACX,YAAY;AAChB;;AAEA,wCAAwC;AACxC;IACI,gCAAgC;AACpC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,YAAY;IACZ,eAAe;IACf,WAAW;AACf;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,yBAAyB;AAC7B;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA,wCAAwC;;;AAGxC;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,0BAA0B;IAC1B,eAAe;AACnB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,mBAAmB;IACnB,6BAA6B;IAC7B,6BAA6B;IAC7B,qCAAqC;AACzC;;AAEA;IACI;QACI,SAAS;IACb;;IAEA,kDAAkD;IAClD,mBAAmB;IACnB,oBAAoB;IACpB,uBAAuB;IACvB,IAAI;IACJ;QACI,SAAS;QACT,WAAW;QACX,WAAW;QACX,YAAY;IAChB;;AAEJ;;AAEA;;IAEI;;;QAGI,eAAe;IACnB;AACJ;;AAEA;IACI;QACI,WAAW;IACf;IACA;QACI,aAAa;QACb,eAAe;IACnB;AACJ;AACA;IACI;;;QAGI,gCAAgC;IACpC;IACA;QACI,aAAa;IACjB;;IAEA;;;QAGI,gBAAgB;IACpB;;IAEA;;;QAGI,gBAAgB;IACpB;;IAEA,qDAAqD;IACrD,uBAAuB;IACvB,IAAI;AACR;;AAEA;IACI;QACI,aAAa;IACjB;;IAEA;QACI,eAAe;QACf,sBAAsB;IAC1B;IACA;QACI,gCAAgC;IACpC;IACA;QACI,mBAAmB;IACvB;IACA;QACI,cAAc;IAClB;AACJ;;AAEA;;IAEI;;;QAGI,eAAe;IACnB;AACJ;;AAEA;IACI;QACI,iBAAiB;IACrB;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,0BAA0B;IAC9B;IACA;QACI,sCAAsC;IAC1C;IACA;QACI,oBAAoB;IACxB;AACJ;;AAEA;IACI;QACI,eAAe;IACnB;;IAEA;QACI,WAAW;QACX,eAAe;IACnB;;IAEA;QACI,0BAA0B;IAC9B;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,gBAAgB;IACpB;AACJ;;AAEA;;IAEI;QACI,SAAS;QACT,WAAW;QACX,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,eAAe;QACf,YAAY;IAChB;;IAEA;QACI,eAAe;QACf,gBAAgB;IACpB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,eAAe;QACf,gBAAgB;IACpB;;IAEA;QACI,eAAe;QACf,gBAAgB;IACpB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,YAAY;QACZ,eAAe;IACnB;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,YAAY;QACZ,iBAAiB;IACrB;;IAEA;QACI,SAAS;QACT,QAAQ;QACR,WAAW;QACX,YAAY;IAChB;;IAEA;;;QAGI,gBAAgB;IACpB;;IAEA;QACI,eAAe;IACnB;AACJ;;AAEA;IACI;QACI,YAAY;IAChB;;IAEA;QACI,WAAW;QACX,eAAe;QACf,YAAY;IAChB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;;;QAGI,eAAe;IACnB;AACJ;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,QAAQ;IACR,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,eAAe;AACnB;;AAEA;IAEI,SAAS;IACT,yBAAyB;AAC7B;;AAEA;IACI;;;;oBAIgB;AACpB;;AAEA;IACI,YAAY;IACZ,mBAAmB;IACnB,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,sBAAsB;IACtB,iCAAiC;AACrC;;AAEA;IACI,WAAW;IACX,eAAe;IACf,YAAY;IACZ,eAAe;IACf,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,eAAe;IACf,kBAAkB;IAClB,0BAA0B;IAC1B,iBAAiB;IACjB,yBAAyB;IACzB,mBAAmB;IACnB,oBAAoB;IACpB,0BAA0B;IAC1B,0CAA0C;IAC1C,wBAAwB;AAC5B;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,UAAU;IACV,UAAU;IACV,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,qBAAqB;IACrB,kBAAkB;IAClB,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB;yBACqB;IACrB,gBAAgB;IAChB,eAAe;IACf,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,wCAAwC;IACxC,oCAAoC;IACpC,mBAAmB;AACvB;;AAEA;IACI,wCAAwC;IACxC,oCAAoC;IACpC,6BAA6B;IAC7B,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,UAAU;IACV,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,aAAa;IACb,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;IACnB,yBAAyB;IACzB,iBAAiB;IACjB,WAAW;IACX,4BAA4B;AAChC;;AAEA;;;IAGI,gBAAgB;IAChB,YAAY;IACZ,eAAe;AACnB;;AAEA;;GAEG;;AAEH;IACI,mBAAmB;IACnB,YAAY;IACZ,eAAe;IACf,uBAAuB;IACvB,4CAA4C;AAChD;;AAEA;IACI,aAAa;IACb,gBAAgB;IAChB,mBAAmB;IACnB,iCAAiC;AACrC;;AAEA;IACI,WAAW;IACX,eAAe;IACf,YAAY;IACZ,eAAe;IACf,iBAAiB;IACjB,mBAAmB;IACnB,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,iBAAiB;IACjB,yBAAyB;IACzB,sBAAsB;IACtB,mBAAmB;IACnB,sCAAsC;AAC1C;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,YAAY;AAChB;;AAEA,gBAAgB;AAChB,2DAA2D;AAC3D,kCAAkC;AAClC,IAAI;;AAEJ;IACI,eAAe;IACf,UAAU;IACV,2BAA2B;IAC3B,uBAAuB;IACvB,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,OAAO;IACP,SAAS;AACb;;AAEA;IACI,6BAA6B;IAC7B,UAAU;AACd;;AAEA;IACI,YAAY;IACZ,mBAAmB;IACnB,kBAAkB;IAClB,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,iBAAiB;IACjB,uBAAuB;IACvB,kBAAkB;AACtB;;AAEA;IACI,8BAA8B;IAC9B,oCAAoC;IACpC,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,yBAAyB;IACzB,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,sBAAsB;IACtB,YAAY;IACZ,cAAc;;IAEd,0DAA0D;AAC9D;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,uDAAuD;IACvD,WAAW;IACX,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,sBAAsB;IACtB,WAAW;IACX,YAAY;IACZ,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;IAChB,eAAe;IACf,sBAAsB;IACtB,oBAAoB;AACxB;;AAEA;;;;;;;;;;;;;GAaG;;AAEH;IACI,mBAAmB;IACnB,WAAW;IACX,UAAU;IACV,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,0CAA0C;IAC1C,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,aAAa;IACb,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;IACzB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,cAAc;IACd,SAAS;AACb;AACA;IACI,yBAAyB;AAC7B;;AAEA;IACI;QACI,cAAc;IAClB;AACJ;;AAEA;;IAEI;;QAEI,sBAAsB;QACtB,uBAAuB;IAC3B;AACJ;;AAEA;IACI,eAAe;IACf,qBAAqB;IACrB,gBAAgB;IAChB,mBAAmB;IACnB,mBAAmB;IACnB,YAAY;IACZ,aAAa;IACb,cAAc;IACd,iBAAiB;IACjB,gBAAgB;IAChB,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,MAAM;AACV;;;AAGA,YAAY;;;AAGZ;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,cAAc;IACd,WAAW;IACX,QAAQ;IACR,qBAAqB;IACrB,6BAA6B;AACjC;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,sBAAsB;IACtB,eAAe;IACf,wBAAwB;IACxB,cAAc;IACd,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,6BAA6B;IAC7B,cAAc;AAClB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,cAAc;IACd,mBAAmB;IACnB,YAAY;IACZ,WAAW;IACX,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,aAAa;IACb,cAAc;IACd,QAAQ;AACZ;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,WAAW;IACX,gBAAgB;IAChB,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,qBAAqB;AACzB;AACA;IACI,qBAAqB;IACrB,eAAe;AACnB;;AAEA;IACI,2BAA2B;IAC3B,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,2BAAsB;IAAtB,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,cAAc;IACd,eAAe;IACf,oBAAoB;AACxB;;AAEA;IACI,qBAAqB;AACzB;AACA;IACI,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,uBAAuB;IACvB,sBAAsB;IACtB,kBAAkB;IAClB,qCAAqC;IACrC,aAAa;AACjB;AACA;GACG,aAAa;GACb,mBAAmB;GACnB,SAAS;AACZ;AACA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;AACtB;AACA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,eAAe;AACnB;AACA;IACI,aAAa;AACjB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,eAAe;IACf,oBAAoB;AACxB;AACA;IACI,yBAAyB;IACzB,UAAU;IACV,WAAW;IACX,YAAY;IACZ,iBAAiB;AACrB;AACA;;IAEI,cAAc;AAClB;AACA;IACI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;IAClB,mBAAmB;IACnB,cAAc;IACd,yBAAyB;IACzB,eAAe;IACf,eAAe;AACnB;AACA;IACI,aAAa;AACjB;AACA;IACI,qBAAqB;IACrB,mBAAmB;IACnB,cAAc;AAClB;AACA;IACI,aAAa;AACjB;;AAEA;IACI;QACI,eAAe;QACf,mBAAmB;IACvB;IACA;QACI,mBAAmB;IACvB;;AAEJ;;AAEA;IACI;QACI,gBAAgB;QAChB,oBAAoB;;IAExB;;;AAGJ;;AAEA;IACI;QACI,sBAAsB;IAC1B;;IAEA;QACI,eAAe;IACnB;AACJ;AACA;IACI;QACI,UAAU;IACd;AACJ;AACA;IACI;QACI,iBAAiB;QACjB,SAAS;IACb;IACA;QACI,UAAU;IACd;IACA;QACI,UAAU;IACd;AACJ;AACA;IACI;QACI,QAAQ;IACZ;IACA;QACI,2BAA2B;IAC/B;IACA;QACI,aAAa;QACb,mBAAmB;IACvB;IACA;QACI,mBAAmB;IACvB;AACJ;AACA;IACI;QACI,OAAO;IACX;AACJ;AACA;IACI;QACI,OAAO;IACX;AACJ;AACA;IACI;QACI,cAAc;QACd,uBAAuB;IAC3B;AACJ","sourcesContent":[".mygroup .title-img-area .nature-text .nature-sub h5 {\n    width: 100%;\n    font-weight: 400;\n    font-size: 20px;\n    color: #0f062b;\n    margin-bottom: 0;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n}\n\n.mygroup .title-img-area .nature-text .nature-sub .group-title {\n    width: 110%;\n    font-weight: 500;\n    font-size: 20px;\n    color: #0f062b;\n    margin-bottom: 0;\n    /*white-space: nowrap;*/\n    /*overflow: hidden;*/\n    /*text-overflow: ellipsis;*/\n    min-width: 40px;\n    padding: 0 0px;\n}\n\n\n.mygroup .group-title:focus {\n    /*background: #fff;*/\n    border: 1px solid #888;\n    border-radius: 3px;\n}\n\n.meetingCal{\n    cursor: pointer;\n}\n\n.mygroup .title-img-area .nature-text .nature-btn-aera .btn-invite button,\n.mygroup .title-img-area .nature-text .nature-btn-aera button.like {\n    border: 0;\n    outline: 0;\n    background: #ffffff;\n    border: 1px solid #f8f8f8;\n    border-radius: 4px;\n    width: 32px;\n    height: 32px;\n}\n\n.addEvent{\n    font-weight: 500;\n    font-size: 15px;\n    color: #6c757d;\n    margin-left: 10px;\n}\n\n::ng-deep .owl-carousel.owl-loading {\n    opacity: unset;\n    display: block;\n}\n\n/* mygroup style */\n/*.mygroup .title-img-area .nature-div {*/\n/*    overflow: hidden;*/\n/*    min-width: 35vh;*/\n/*    width: fit-content;*/\n/*    position: relative;*/\n/*    background-color: #eaeaea;*/\n/*    display: flex;*/\n/*    border-radius: 8px;*/\n/*}*/\n\n.joinGroup button {\n    border: 1px solid #6c2fbb;\n    padding: 4px 20px;\n    font-size: 15px;\n    border-radius: 0.2rem;\n    color: #fff;\n    background-color: #6c2fbb;\n    margin-top: 10px;\n}\n\n.QRcode p {\n    font-size: 15px;\n    font-weight: 500;\n    color: black;\n}\n\n.QRcode {\n    display: flex;\n    align-items: flex-start;\n    margin-top: 5px;\n    cursor: pointer;\n    width: fit-content;\n}\n\n.mygroup .title-img-area .nature-div {\n    cursor: pointer;\n    display: flex;\n    justify-content: center;\n    height: 180px;\n    min-width: 280px;\n    max-width: 280px;\n    width: 100%;\n    border-radius: 16px;\n    overflow: hidden;\n    position: relative;\n    /* background: #eaeaea; */\n}\n\nbutton.edit {\n    margin-left: 10px;\n    top: 6px;\n    /* right: 36px; */\n    /* right: -43px; */\n    right: 5px;\n    content: \"\";\n    width: 28px;\n    height: 28px;\n    background: transparent;\n    border-radius: 6px;\n    border: 0;\n    overflow: hidden;\n}\n\n.mygroup .title-img-area .nature-div button.edit {\n    position: absolute;\n}\n\n.mygroup .title-img-area .nature-img {\n    max-width: 419px;\n    width: 100%;\n    max-height: 215px;\n    height: 100%;\n    border-radius: 8px;\n    position: relative;\n}\n\n.mygroup .expandImg {\n    position: absolute;\n    top: 7px;\n    z-index: 1;\n    right: 40px;\n    background: #7a2df9;\n    padding: 0 3px;\n    border: 1px solid white;\n}\n\n.mygroup .expandImg img {\n    width: 18px;\n}\n\n.dropExpand {\n    position: absolute;\n    right: 0;\n}\n\n.dropExpand .dropdown-menu.show {\n    position: absolute;\n    transform: translate3d(-36px, 33px, 0px);\n    top: -1px !important;\n    left: -65px !important;\n    min-width: 4rem !important;\n    text-align: center !important;\n    background-color: white !important;\n    padding: 0 !important;\n}\n\n.dropdown-toggle::after {\n    display: none;\n}\n\na.dropdown-item.activeImgSetting {\n    background-color: #f1eafe;\n    color: #6c2fbb;\n}\n\n.mygroup .title-img-area .nature-text {\n    width: 100%;\n    /*padding-left: 20px;*/\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n    margin: 15px 0px;\n}\n\n.mygroup .title-img-area .nature-text .nature-sub {\n    /*display: flex;*/\n    align-items: center;\n    padding-left: 25px;\n    gap: 10px;\n}\n\n.mygroup .title-img-area .nature-text .nature-sub button.edit {\n    width: 27.54px;\n    height: 27.54px;\n    background: transparent;\n    border-radius: 6px;\n    border: 0;\n    outline: 0;\n    overflow: hidden;\n}\n\n.mygroup .title-img-area .nature-text .nature-btn-aera .btn-invite span {\n    font-weight: 400;\n    font-size: 15px;\n    color: #727272;\n}\n\n.btn-invite button .fa-sort {\n    font-size: 14px;\n}\n\n.mygroup .title-img-area .nature-text .nature-btn-aera .btn-invite button {\n    font-size: 21px;\n    color: #0f062b;\n    font-weight: 900;\n}\n\n.mygroup .title-img-area .emo {\n    width: 100%;\n    max-width: 800px;\n    font-weight: 500;\n    font-size: 15px;\n    color: #727272;\n    min-height: 30px;\n    margin-bottom: 0;\n    display: flex;\n    -webkit-line-clamp: 1;\n    -webkit-box-orient: vertical;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    padding: 0 0px;\n    min-width: 40px;\n}\n\n.mygroup .title-img-area .emo:focus {\n    /*background: #fff;*/\n    border: 1px solid #888;\n    border-radius: 3px;\n}\n\n.mygroup .title-img-area .private-div {\n    display: flex;\n    align-items: center;\n    gap: 6px;\n}\n\n.mygroup .title-img-area .private-div p {\n    font-weight: 500;\n    font-size: 15px;\n    color: #bcbcbc;\n    margin-bottom: 0;\n    margin-top: 2px;\n}\n\n.mygroup .title-img-area .private-div a {\n    text-decoration: none;\n}\n\n.mygroup .admin-area h2 {\n    font-weight: 400;\n    font-size: 26px;\n    color: #0f062b;\n    margin-bottom: 0;\n}\n\n.edit-title-group .edit {\n    display: none;\n}\n\n.edit-title-group:hover .edit {\n    display: inline-flex;\n}\n\n.mygroup .admin-area .add-title {\n    font-weight: 400;\n    font-size: 26px;\n    color: #0f062b;\n    margin-bottom: 0;\n    min-width: 40px;\n    padding: 0 2px;\n}\n\n.mygroup .admin-area .add-title:focus {\n    /*background: #fff;*/\n    border: 1px solid #888;\n    border-radius: 3px;\n}\n\n.btn-subscribe {\n    border: 1px solid #6c2fbb;\n    padding: 0.25rem 0.5rem;\n    font-size: .875rem;\n    line-height: 1.5;\n    border-radius: 0.2rem;\n    display: inline-block;\n    font-weight: 400;\n    text-align: center;\n    vertical-align: middle;\n    transition: color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out;\n}\n\n.btn-subscribe.subscribe:hover {\n    color: #fff;\n    background-color: #6c2fbb;\n}\n\n.btn-subscribe.subscribe {\n    color: #6c2fbb;\n    background-color: #fff;\n    cursor: pointer;\n}\n\n.btn-subscribe.subscribed {\n    color: #fff;\n    background-color: #6c2fbb;\n}\n\n.btn-invite {\n    justify-content: flex-end;\n    margin: 20px 0;\n}\n\n.btn-invite span {\n    cursor: pointer;\n    font-weight: 400;\n    font-size: 15px;\n    color: #6c2fbb;\n}\n\n.btn-invite button {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-size: 21px;\n    color: #6c2fbb;\n    /*font-weight: 900;*/\n    outline: 0;\n    background: #e1e1f9;\n    border: none;\n    border-radius: 4px;\n    width: 26px;\n    height: 26px;\n}\n.admin-select {\n    font-size: 14px;\n    padding: 4px 10px;\n    border: none;\n}\n.grp-edition {\n    min-width: auto;\n}\n.btn-custom  {\n    padding-right: 35px;\n}\n.btn-custom .group {\n    background: transparent;\n    outline: none;\n    border: none;\n    color: #6c2fbb;\n    font-weight: 600;\n    text-align: right;\n    margin: .5rem !important;\n    /*white-space: nowrap;*/\n}\n\n.mygroup .admin-area .border-group {\n    background: #FFFFFF;\n    border: 1px solid #F8F8F8;\n    border-radius: 16px;\n    padding: 10px 35px;\n}\n\n.image-button-box {\n    display: flex;\n    /*align-items: end;*/\n    /*justify-content: space-between;*/\n    gap: 10px;\n}\n.show-admin {\n    margin-bottom: 10px;\n}\n.view-all {\n    padding-top: 30px;\n}\n\n.view-all button {\n    border: none;\n    font-weight: 700;\n    font-size: 12px;\n    color: #6c2fbb;\n    text-decoration: none;\n    background-color: transparent;\n}\n\n.view-all button span {\n    line-height: 4px;\n    font-size: 16px;\n}\n\n.mygroup .admin-area .activeted {\n    display: flex;\n    flex-direction: column;\n    text-align: center;\n    align-items: center;\n    gap: 16px;\n    margin-top: 8px;\n}\n.admin-img-profile {\n    position: relative;\n    width: fit-content;\n    margin-inline: auto;\n}\n.admin-img-profile::after {\n    position: absolute;\n    top: -2px;\n    right: -4px;\n    width: 10px;\n    height: 10px;\n    background: #ff0909;\n    content: \"\";\n    border-radius: 50%;\n}\n.mygroup .admin-area .activeted .active-imger {\n    cursor: pointer;\n    position: relative;\n    width: 50px;\n    height: 50px;\n    border-radius: 9px;\n    box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15);\n}\n\n.mygroup .admin-area .activeted .active-imger.active::after {\n    position: absolute;\n    top: -2px;\n    right: -4px;\n    width: 10px;\n    height: 10px;\n    background: #ff0909;\n    content: \"\";\n    border-radius: 50%;\n}\n\n.mygroup .admin-area .activeted .active-imger img {\n    width: 100%;\n    height: 100%;\n    border-radius: 9px;\n    object-fit: cover;\n}\n\n.mygroup .admin-area .activeted h6 {\n    cursor: pointer;\n    font-weight: 400;\n    font-size: 16px;\n    color: #000000;\n    margin-bottom: 0;\n}\n\n.mygroup .admin-area .activeted p {\n    font-weight: 400;\n    font-size: 14px;\n    color: #727272;\n    margin-bottom: 0;\n}\n\n.mygroup .admin-area .activeted-btns {\n    display: flex;\n    align-items: center;\n    /* width: fit-content; */\n    gap: 8px;\n    /* margin-top: 8px; */\n}\n\n.mygroup .admin-area .activeted-btns button {\n    border: none;\n    width: 30px;\n    height: 30px;\n    background: #F8FAFB;\n    border-radius: 4px;\n    color: #0F062B;\n    font-size: 20px;\n    font-weight: 900;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.mygroup .admin-area .activeted-btns p {\n    font-weight: 400;\n    font-size: 15px;\n    color: #727272;\n    margin-bottom: 0;\n}\n\n.mygroup .content-page {\n    background: #ffffff;\n    border: 1px solid #f8f8f8;\n    border-radius: 16px;\n    padding: 10px 40px 10px 40px;\n}\n\n.mygroup .content-page .content-area img {\n    /*border-radius: 8px;*/\n    /*width: 100%;*/\n    max-width: 100%;\n    object-fit: cover;\n    /* object-fit: contain; */\n}\n\n.mygroup .content-page .content-area h4 {\n    font-weight: 400;\n    font-size: 16px;\n    color: #0f062b;\n    margin-top: 15px;\n    margin-bottom: 15px !important;\n}\n\n.content-area .img-box {\n    aspect-ratio: 16/9;\n    cursor: pointer;\n    width: 100%;\n    /*height: 270px;*/\n    /*height: 250px;*/\n    border-radius: 10px;\n    overflow: hidden;\n    display: flex;\n    /*position: relative;*/\n    background: #f8f9fa;\n    text-align: center;\n    justify-content: center;\n}\n\n\n\n.rag-body {\n    max-height: 80vh;\n    overflow: auto;\n}\n\n.rag-list {\n    width: 500px;\n    max-width: 100%;\n    border: solid 1px #ccc;\n    min-height: 60px;\n    display: block;\n    background: white;\n    border-radius: 4px;\n    overflow: hidden;\n}\n\n.rag-list.cdk-drop-list-dragging .rag-box:not(.cdk-drag-placeholder) {\n    transition: transform 250ms cubic-bezier(0, 0, 0.2, 1);\n}\n\n.rag-box:last-child {\n    border: none;\n}\n\n.rag-box {\n    padding: 10px;\n    border-bottom: solid 1px #ccc;\n    color: rgba(0, 0, 0, 0.87);\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    justify-content: space-between;\n    box-sizing: border-box;\n    cursor: move;\n    background: white;\n    font-size: 14px;\n    z-index: 99999;\n}\n\n#reOrderGroupTab .rag-box,\n#reOrderGroupTopic .rag-box {\n    padding: 10px;\n    border-bottom: solid 1px #ccc;\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    justify-content: space-between;\n    box-sizing: border-box;\n    cursor: move;\n    background: white;\n    z-index: 99999;\n    font-size: 18px;\n    font-weight: 500;\n    color: #878395;\n}\n\n.rag-box:last-child {\n    border: none;\n}\n\n.rag-custom-placeholder {\n    background: #ccc;\n    border: dotted 3px #999;\n    min-height: 110px;\n    transition: transform 250ms cubic-bezier(0, 0, 0.2, 1);\n}\n\n#reOrderGroupTab .rag-custom-placeholder,\n#reOrderGroupTopic .rag-custom-placeholder {\n    background: #ccc;\n    border: dotted 3px #999;\n    min-height: 50px;\n    transition: transform 250ms cubic-bezier(0, 0, 0.2, 1);\n}\n\n.rag-img-box {\n    width: 100px;\n    height: 80px;\n    margin-right: 10px;\n    display: flex;\n    justify-content: center;\n    border-radius: 8px;\n    background: #f8f9fa;\n}\n\n.rag-img {\n    height: 100%;\n    width: 100%;\n    object-fit: contain;\n}\n::ng-deep .my-dialog {\n    justify-content: center;\n}\n::ng-deep .my-dialog .mdc-dialog {\n    display: flex !important\n}\n\n::ng-deep .my-dialog .mdc-dialog__container {\n    width: 500px !important;\n}\n\n::ng-deep .my-dialog .mdc-dialog__container {\n    width: 500px !important;\n}\n\n::ng-deep .cdk-overlay-pane.questionnairesDashboard {\n    background: #f8fafb;\n    margin-block: 30px !important;\n    position: relative !important;\n    height: calc(100vh - 50px) !important;\n}\n::ng-deep .cdk-overlay-pane.questionnairesDashboard .mat-mdc-dialog-surface {\n    overflow: hidden;\n}\n\n@media (max-width: 1700px) {\n    .content-area .img-box {\n        height: 240px\n    }\n}\n\n@media (max-width: 1600px) {\n    .content-area .img-box {\n        height: 220px\n    }\n}\n\n@media (max-width: 1440px) {\n    .content-area .img-box {\n        height: 200px;\n    }\n    \n    ::ng-deep .cdk-overlay-pane.analytics-modal {\n        width: 88% !important;\n    }\n}\n\n@media (max-width: 1200px) {\n    .content-area .img-box {\n        height: 160px;\n    }\n}\n\n@media (max-width: 1024px) {\n    .content-area .img-box {\n        height: 120px;\n    }\n}\n\n\n@media (max-width: 1200px) {\n    .btn-custom .group {\n        max-width: 160px;\n        \n    }\n}\n@media (max-width: 480px) {\n    ::ng-deep .my-dialog {\n        max-width: 98% !important;\n    }\n}\n\n\n.dots {\n    position: absolute;\n    top: 12px;\n    right: 35px;\n    /*background-color: #000000a2;*/\n    background-color: #929292a2;\n    display: flex;\n    cursor: pointer;\n    align-items: center;\n    column-gap: 10px;\n    padding: 7px 12px;\n    border-radius: 5px;\n}\n\n.mygroup .discussion {\n    display: flex;\n    /* align-items: center; */\n    gap: 10px;\n    width: 100%;\n}\n\n.mygroup .discussion .discussion-preview {\n    box-shadow: 0 .15rem .25rem rgba(0, 0, 0, .075);\n    position: relative;\n    border: 1px solid #3d3e3e;\n    border-radius: 8px;\n    padding: 5px;\n    margin: 2px;\n    height: 70px;\n    width: 70px;\n}\n\n.mygroup .discussion .discussion-preview .loader {\n    position: absolute;\n    border: 5px solid #f3f3f3;\n    border-radius: 50%;\n    border-top: 5px solid #6c2fbb;\n    width: 60px;\n    height: 60px;\n    -webkit-animation: spin 2s linear infinite;\n    /* Safari */\n    animation: spin 2s linear infinite;\n}\n\n#reOrderGroupTab .rag-title,\n#reOrderGroupTopic .rag-title {\n    font-size: 18px;\n    font-weight: 500;\n    color: #878395;\n}\n\n.assignBadge p {\n    cursor: pointer;\n    padding: 4px 10px;\n    color: #6e5eff;\n    border: 1px solid #6e5eff;\n    border-radius: 2rem;\n    font-weight: 500;\n    width: fit-content;\n    margin-top: 15px;\n}\n\n.badge-box .badge-rounded {\n    z-index: 0 !important;\n    width: 65px;\n    height: 65px;\n}\n\n.badge-box {\n    background: mediumpurple;\n    width: 6em;\n    height: 6em;\n    border-radius: 20%;\n    display: inline-block;\n    transition: all 0.2s ease;\n    box-shadow: 8px 10px 12px 3px rgba(0, 0, 0, 0.2);\n    position: relative;\n}\n\n.assignBadge p:hover {\n    background-color: #6e5eff3b;\n}\n\n.selectedBadge {\n    position: relative;\n    width: fit-content;\n    margin-top: 30px;\n}\n\n.selectedBadge .cross-icon {\n    position: absolute;\n    right: -5px;\n    background-color: beige;\n    padding: 0 4px;\n    z-index: 1;\n    background-blend-mode: overlay;\n    height: 20px;\n    width: 20px;\n    border-radius: 50px;\n    top: -4px;\n    filter: invert(1);\n    cursor: pointer;\n}\n\n.badgeSvg svg {\n    fill: none !important;\n    height: 25px !important;\n    width: 23px !important;\n    margin-left: 5px !important;\n}\n\n.actionButton {\n    /* position: absolute; */\n    bottom: 0;\n    display: flex;\n    gap: 10px;\n    width: 100%;\n    justify-content: flex-end;\n    padding: 5px;\n    background-color: white;\n    /* border: 1px solid #959697;\n    border-top: 1px solid #d6d6d6; */\n    border-left: 1px solid #959697;\n    border-right: 1px solid #959697;\n    border-bottom: 1px solid #959697;\n}\n\n.reply .actionButton {\n    bottom: 30px !important;\n}\n\n.actionButton button {\n    background: #6c2fbb;\n    border-radius: 5px !important;\n    padding: 4px 8px;\n    height: unset !important;\n    width: unset !important;\n    border: none !important;\n}\n.actionButton .btnCancel {\n    background: #6c2fbb;\n    border-radius: 5px !important;\n    padding: 4px 8px;\n    height: unset !important;\n    width: unset !important;\n    font-size: 15px;\n    color: white;\n    border: none !important;\n}\n\n.actionButton button img {\n    filter: invert(1);\n}\n\n.actionButton button label {\n    color: white !important;\n    padding: 0 !important;\n    margin: 0 !important;\n}\n\n\n::ng-deep .comment-text span.spanComment p {\n    margin: 0 !important;\n}\n::ng-deep .comment-text p {\n    position: relative !important;\n}\n\n::ng-deep .comment-text span.replyComment p {\n    margin: 0 !important;\n}\n\n::ng-deep .comment-text span.spanComment img {\n    height: 100px !important;\n    width: 150px !important;\n    border-radius: 4px !important;\n}\n\n::ng-deep .comment-text span.replyComment p img {\n    height: 100px !important;\n    width: 150px !important;\n    border-radius: 4px !important;\n}\n\n#update_comment .modal-dialog {\n    max-width: 530px;\n}\n\n.dots-dropdown .dropdown-item:active,\n.dots-dropdown .dropdown-item:hover {\n    background-color: #d3d2d2;\n    color: #000;\n}\n\n\n/* Safari */\n@-webkit-keyframes spin {\n    0% {\n        -webkit-transform: rotate(0deg);\n    }\n\n    100% {\n        -webkit-transform: rotate(360deg);\n    }\n}\n\n@keyframes spin {\n    0% {\n        transform: rotate(0deg);\n    }\n\n    100% {\n        transform: rotate(360deg);\n    }\n}\n\n.mygroup .discussion .discussion-preview .delete-btn {\n    display: none;\n    text-align: center;\n    padding: 2px 5px;\n    background: #D9D9D9;\n    border-radius: 100%;\n    position: absolute;\n    line-height: 1;\n    right: -10px;\n    top: -10px;\n}\n\n.mygroup .discussion .discussion-preview:hover .delete-btn {\n    display: block;\n}\n\n.mygroup .discussion .mini-discussion {\n    width: 100%;\n    position: relative;\n}\n\n.mygroup .discussion .mini-discussion textarea {\n    padding: 10px;\n    background: #ffffff;\n    border: 1px solid #f8f8f8;\n    border-radius: 8px;\n    font-weight: 500;\n    font-size: 15px;\n    width: 100%;\n    text-indent: 40px;\n    outline: 0;\n}\n\n.mygroup .discussion .mini-discussion textarea::placeholder {\n    color: #bbbbbb;\n}\n\n.mygroup .discussion .mini-discussion img {\n    position: absolute;\n    left: 7px;\n    top: 7px;\n    border-radius: 4px;\n    width: 32px;\n    height: 32px;\n    object-fit: cover;\n}\n\n.mygroup .discussion .mini-discussion .att-btn {\n    margin: 0;\n    padding: 5px;\n    position: absolute;\n    right: 7px;\n    top: 3px;\n    border: none;\n    border-radius: 4px;\n    width: 32px;\n    height: 32px;\n    background: #f1eafe;\n    color: #6c2fbb;\n}\n\n.mygroup .discussion .mini-discussion .profile-image {\n    position: absolute;\n    left: 7px;\n    top: 7px;\n    border-radius: 4px;\n    width: 32px;\n    height: 32px;\n    font-size: 15px;\n}\n\n.attachments .attachments-item {\n    width: auto !important;\n}\n\n/* .mygroup .discussion .mini-discussion p {\n    font-weight: 500;\n    font-size: 15px;\n    color: #383144;\n    margin-bottom: 0;\n} */\n\n.mygroup .discussion .db-btn {\n    background: #6c2fbb;\n    border-radius: 8px;\n    outline: none;\n    border: none;\n    max-width: 120px;\n    width: 100%;\n    height: 48px;\n    color: #ffffff;\n}\n\n.comment-video {\n    cursor: pointer;\n    display: inline-block;\n    height: 60px;\n    position: relative;\n}\n\n.comment-video .playicon {\n    color: #6c2fbb;\n    border-radius: 50%;\n    font-size: 24px;\n    position: absolute;\n    left: 50%;\n    top: 50%;\n    -webkit-transform: translate(-50%, -50%);\n    -moz-transform: translate(-50%, -50%);\n    -ms-transform: translate(-50%, -50%);\n    -o-transform: translate(-50%, -50%);\n    transform: translate(-50%, -50%);\n}\n\n.comment-video img {\n    width: auto;\n    height: inherit;\n}\n\n.mygroup .dis-middle .data-list .weekend {\n    display: flex;\n    gap: 8px;\n    padding: 10px;\n    margin: 8px 2px;\n    /*margin-bottom: 18px;*/\n}\n\n/* .weekend{\n    width: fit-content;\n} */\n\n.mygroup .dis-middle .data-list .weekend:hover {\n    /* background-color: #fafafa; */\n    box-shadow: 0 0 2px 0 rgb(0 0 0 / 50%);\n}\n\n/*.mygroup .dis-middle .data-list .weekend img {*/\n/*    border-radius: 4px;*/\n/*    width: 32px;*/\n/*    height: 32px;*/\n/*    object-fit: cover;*/\n/*    position: absolute;*/\n/*}*/\n\n.mygroup .dis-middle .data-list .weekend .profile-image {\n    border-radius: 4px;\n    width: 32px;\n    height: 32px;\n    position: absolute;\n    /* object-fit: contain; */\n    object-fit: cover;\n    font-size: 15px;\n    cursor: pointer;\n}\n\n.mygroup .dis-middle .data-list .weekend .ago {\n    display: flex;\n    align-items: center;\n    flex-wrap: wrap;\n}\n\n.mygroup .dis-middle .data-list .weekend .ago h6 {\n    cursor: pointer;\n    font-weight: 500;\n    font-size: 15px;\n    color: #0f062b;\n    margin-bottom: 0;\n    margin-right: 4px;\n    white-space: nowrap;\n}\n\n.mygroup .dis-middle .data-list .weekend .ago span.span {\n    font-weight: 900;\n    font-size: 15px;\n    color: #0f062b;\n    margin: 0 5px;\n}\n\n.mygroup .dis-middle .data-list .weekend .ago span {\n    font-weight: 500;\n    font-size: 12px;\n    color: #878395;\n}\n\n.mygroup .dis-middle .data-list .weekend .meni {\n    width: 100%;\n    margin-left: 40px;\n}\n\n.mygroup .dis-middle .data-list .weekend .meni .comment-text {\n    margin-bottom: 0;\n    font-weight: 400;\n    font-size: 15px;\n    /*color: #878395;*/\n}\n\n.mygroup .dis-middle .data-list .weekend .meni .lier {\n    display: flex;\n    align-items: center;\n    /* width: 400px; */\n}\n\n.mygroup .dis-middle .data-list .weekend .meni .lier .sub {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n}\n\n.mygroup .dis-middle .data-list .weekend .meni .lier .sub-2 {\n    min-width: 150px;\n    width: 100%;\n}\n\n.mygroup .dis-middle .data-list .weekend .meni .lier .sub-2 button,\n.mygroup .dis-middle .data-list .weekend .meni .lier .sub button {\n    border: 0;\n    outline: 0;\n    background-color: transparent;\n    padding: 5px;\n}\n\n.mygroup .dis-middle .data-list .weekend .meni .lier .sub .zero {\n    font-weight: 400;\n    font-size: 13px;\n    color: #0f062b;\n    margin-bottom: 0;\n}\n\n.mygroup .dis-middle .data-list .weekend .meni .lier .sub-2 .zero {\n    font-size: 14px;\n    color: #007bff;\n    font-weight: 500;\n}\n\n.mygroup .dis-middle .data-list .weekend .meni .lier .sub-2 .zero svg {\n    margin-left: 5px;\n    margin-bottom: 2px;\n}\n\n.mygroup .dis-middle .data-list .weekend:hover .meni .lier .sub-3 {\n    display: flex;\n}\n\n.mygroup .dis-middle .data-list .weekend .meni .lier .sub-3 {\n    display: none;\n    align-items: center;\n    gap: 8px;\n}\n\n.mygroup .dis-middle .data-list .weekend .meni .lier .sub-3 button {\n    width: 59px;\n    height: 30px;\n    border-radius: 5px;\n    font-weight: 400;\n    font-size: 12px;\n    color: #ffffff;\n    border: 0;\n    outline: 0;\n}\n\n.mygroup .dis-middle .data-list .weekend .meni .lier .sub-3 button.up {\n    /* background-color: #ab5be9; */\n    background-color: #6c2fbb;\n}\n\n.mygroup .dis-middle .data-list .weekend .meni .lier .sub-3 button.del {\n    background-color: #c401ec;\n}\n\n.tabs {\n    margin-top: 20px;\n    border-top: 1px solid lightgray;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    column-gap: 30px;\n    padding: 10px 0;\n}\n\n.tabs button {\n    background-color: transparent;\n    color: gray;\n    font-weight: 600;\n    font-size: 20px;\n    display: flex;\n    align-items: center;\n    column-gap: 2px;\n}\n\n.tabs button.active {\n    color: #6c2fbb;\n    position: relative;\n}\n\n.tabs button.active::after {\n    position: absolute;\n    content: \"\";\n    width: 100%;\n    height: 2px;\n    top: -11px;\n    left: 0;\n    background-color: #6c2fbb;\n}\n\n.activity-content,\n.like-content,\n.share-content {\n    margin-top: 50px;\n    padding: 0 100px;\n    overflow: auto;\n    /* display: none; */\n}\n\n.activity-content .two-btns,\n.like-content .two-btns,\n.share-content .two-btns {\n    position: absolute;\n    top: 12px;\n    right: 25px;\n    background-color: #000000a2;\n    display: flex;\n    align-items: center;\n    column-gap: 10px;\n    padding: 2px 10px;\n    border-radius: 10px;\n}\n\n.activity-content .two-btns button,\n.like-content .two-btns button,\n.share-content .two-btns button {\n    background-color: transparent;\n    display: flex;\n    align-items: center;\n    column-gap: 5px;\n}\n\n.activity-content .two-btns button img,\n.like-content .two-btns button img,\n.share-content .two-btns button img {\n    width: 13px;\n}\n\n.arrow {\n    width: 23px !important;\n}\n\n.activity-content .two-btns button span,\n.like-content .two-btns button span,\n.share-content .two-btns button span {\n    color: #fff;\n    font-size: 17px !important;\n}\n\n.activity-content p,\n.like-content p,\n.share-content p {\n    margin-bottom: 0;\n    margin-top: 5px;\n}\n\n.activity-content h5,\n.like-content h5,\n.share-content h5 {\n    color: #0f062b;\n    font-weight: 800 !important;\n    font-size: 25px;\n    margin-bottom: 0;\n}\n\n.activity-content span,\n.like-content span,\n.share-content span {\n    font-size: 22px !important;\n    font-weight: 600;\n}\n\n.activity-content span:last-child,\n.like-content span:last-child,\n.share-content span:last-child {\n    color: #6c2fbb;\n}\n\n.activity-content p,\n.like-content p,\n.share-content p {\n    color: #878395;\n}\n\n#display {\n    display: block;\n}\n\n::ng-deep .NgxEditor__Content {\n    height: 85px;\n    overflow: auto;\n    text-align: left;\n}\n\n\n::ng-deep span.spanComment p {\n    /* display: flex; */\n    /* flex-direction: column; */\n}\n\n\n::ng-deep span.spanComment p a.highlight{\n    background: #f1eafe;\n    color: #6c2fbb;\n}\n::ng-deep span.replyComment p a.highlight{\n    background: #f1eafe;\n    color: #6c2fbb;\n}\n::ng-deep span.replyComment p a{\n    background: #f1eafe;\n    color: #6c2fbb;\n}\n::ng-deep span.spanComment p a{\n    background: #f1eafe;\n    color: #6c2fbb;\n}\n::ng-deep .ProseMirror.NgxEditor__Content p a{\n    background: #f1eafe;\n    color: #6c2fbb;\n}\n\n/* ::ng-deep span.spanComment p a{\n    background: #f1eafe;\n    color: #6c2fbb;\n} */\n\n::ng-deep #update_comment .NgxEditor__Content {\n    height: auto;\n    overflow: auto;\n    text-align: left;\n}\n\n::ng-deep #update_comment .NgxEditor__MenuBar {\n    flex-wrap: nowrap !important;\n    padding: 3px 0 !important;\n}\n\n::ng-deep .NgxEditor__Wrapper {\n    border-radius: 0 !important;\n}\n\n::ng-deep .NgxEditor__Popup .NgxEditor__Popup--FormGroup label {\n    margin-bottom: 3px;\n    text-align: left;\n}\n\n\n::ng-deep #update_comment span.NgxEditor__ImageWrapper {\n    width: fit-content !important;\n}\n\n\n::ng-deep .NgxEditor__Dropdown--DropdownMenu {\n    text-align: left;\n}\n\n::ng-deep .NgxEditor__Content p {\n    margin: 0 !important;\n}\n\n::ng-deep .scrollable-menu {\n    max-height: 200px !important;\n}\n\n::ng-deep ul.dropdown-menu.scrollable-menu.mention-menu li a p {\n    margin: 0;\n    padding: 3px 0;\n    font-size: 15px;\n    display: flex;\n    gap: 5px;\n    align-items: center;\n}\n\n::ng-deep ul.dropdown-menu.scrollable-menu.mention-menu li a p span.vl {\n    border-left: 1px solid #cccccc;\n    height: 20px;\n    display: block;\n}\n\n::ng-deep ul.dropdown-menu.scrollable-menu.mention-menu li a p span.fullname {\n    color: #8e8e8e;\n}\n\n::ng-deep .mention-active>a {\n    background-color: #6c2fbb !important;\n}\n\n.tagUserModal {\n    position: absolute;\n    background-color: #f3f3f3;\n    height: 250px;\n    overflow: auto;\n    z-index: 1;\n    /* top: -14px; */\n    border: 1px solid #cccccc;\n    padding: 0 5px 10px;\n    width: -moz-max-content;\n    width: 100%;\n    border-radius: 5px;\n    left: 0;\n    bottom: -17px;\n}\n\n#offcanvasRight .tagUserModal {\n    position: absolute;\n    background-color: #f3f3f3;\n    height: 250px;\n    overflow: auto;\n    z-index: 1;\n    border: 1px solid #cccccc;\n    padding: 0 5px 10px;\n    border-radius: 5px;\n    bottom: 237px;\n    width: 100%;\n    margin-left: 17px;\n    max-width: 582px;\n}\n\n#offcanvasRight #update_comment_reply .tagUserModal {\n    position: absolute;\n    background-color: #f3f3f3;\n    height: 250px;\n    overflow: auto;\n    z-index: 1;\n    border: 1px solid #cccccc;\n    padding: 0 5px 10px;\n    border-radius: 5px;\n    bottom: 123px;\n    width: 100%;\n    margin-left: 0;\n    max-width: 582px;\n}\n\n#offcanvasRight .reply {\n    /* position: fixed !important; */\n    /* bottom: 70px; */\n    /* left: 0; */\n    /* right: -7px; */\n    width: 100%;\n}\n#offcanvasRight .demo {\n    height: calc(100vh - 345px);\n    overflow: auto;\n}\n\n#update_comment .tagUserModal {\n    position: absolute;\n    background-color: #f3f3f3;\n    height: 235px;\n    overflow: auto;\n    z-index: 1;\n    border: 1px solid #cccccc;\n    padding: 0 5px 10px;\n    width: 100%;\n    border-radius: 5px;\n    bottom: 100%;\n    left: 0;\n}\n@media only screen and (max-width: 767px) and (min-width: 200px) {\n    #update_comment .tagUserModal {\n        width: 84%;\n        bottom: 236px;\n    }\n}\n\n.vl {\n    border-left: 1px solid #cccccc;\n    height: 20px;\n    display: block;\n}\n\n.tagUserModal p span {\n    display: block;\n}\n\n.tagUserModal p {\n    padding: 4px 8px;\n}\n\nspan.fullname {\n    color: #8e8e8e;\n}\n\n/* .tagUserModal p:hover {\n    background-color: #f1eafe !important;\n    color: #6c38bf;\n    border-radius: 4px;\n    cursor: pointer;\n} */\n\n.tagUserModal p:hover span.fullname {\n    color: white;\n}\n\n.highlighted {\n    background-color: #f1eafe !important;\n    color: #6c38bf;\n    border-radius: 4px;\n    cursor: pointer;\n}\n\n.tagUserModal p span img {\n    position: unset !important;\n}\n\n.tagUserModal p span.profile-image {\n    position: relative !important;\n    left: 0 !important;\n    line-height: 2.3;\n    font-size: 13px !important;\n    top: 0 !important;\n    width: 28px !important;\n    height: 28px !important;\n}\n\n.tagUserModal p span.username {\n    font-size: 15px;\n    font-weight: 500;\n}\n\n.tagUserModal input {\n    font-size: 15px;\n    font-weight: 500;\n}\n\n.tagUserModal .stickyClass {\n    position: sticky;\n    top: 0;\n    z-index: 1;\n    background-color: #f3f3f3;\n    padding: 10px 0 2px 0;\n}\n.left-arrow,\n.right-arrow {\n    background-color: #ededed;\n    height: 20px;\n    width: 20px;\n    line-height: 18px;\n    text-align: center;\n    cursor: pointer;\n    flex-shrink: 0;\n    border-radius: 9px;\n}\n\n.left-arrow svg,\n.right-arrow svg {\n    width: 10px;\n    height: 10px;\n}\n\n/* =================================== */\n.offcanvas-header {\n    border-bottom: 1px solid #d2d2d2;\n}\n\n.mytextdiv {\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    gap: 5px;\n}\n\n.mytexttitle {\n    flex-grow: 0;\n    font-size: 15px;\n    color: gray;\n}\n\n.divider {\n    flex-grow: 1;\n    height: 1px;\n    background-color: #e0dede;\n}\n\n.offcanvas-end {\n    width: 600px;\n}\n\n.lastReply {\n    color: gray;\n    font-size: 14px;\n    font-weight: 500;\n}\n\n.zero:hover {\n    text-decoration: underline;\n}\n\n/* =================================== */\n\n\n.memberCommunity {\n    font-size: 15px;\n    font-weight: 500;\n    color: #6c757d;\n}\n\n.memberCommunity span {\n    color: #6c2fbb;\n    text-decoration: underline;\n    cursor: pointer;\n}\n\n.pinnedMessages{\n    color: #6c2fbb;\n}\n\nhr{\n    border-color: #777777;\n    border-width: thin;\n    margin: 4px 0 0 0;\n}\n\n::ng-deep .cdk-overlay-pane.analytics-modal {\n    background: #f8fafb;\n    margin-block: 30px !important;\n    position: relative !important;\n    height: calc(100vh - 50px) !important;\n}\n\n@media (max-width: 1300px) {\n    .mygroup .admin-area .activeted {\n        gap: 10px;\n    }\n\n    /*.mygroup .admin-area .activeted .active-imger {*/\n    /*    width: 50px;*/\n    /*    height: 51px;*/\n    /*    min-width: 50px;*/\n    /*}*/\n    .mygroup .admin-area .activeted .active-imger.active::after {\n        top: -4px;\n        right: -4px;\n        width: 13px;\n        height: 13px;\n    }\n\n}\n\n@media (max-width: 1200px) {\n\n    .activity-content,\n    .like-content,\n    .share-content {\n        padding: 0 15px;\n    }\n}\n\n@media (max-width: 1199px) {\n    .admin-area .border-group >div:first-child >div {\n        width: auto;\n    }\n    .show-admin {\n        display: flex;\n        flex-wrap: wrap;\n    }\n}\n@media (max-width: 991px) {\n    .tab-box-video ul li .edit-tab svg,\n    .tab-box-video ul li .delete-tab ,\n     .tab-box-video ul li .pinImage {\n        display: inline-block !important;\n    }\n    .content-area .img-box {\n        height: 205px;\n    }\n\n    .activity-content,\n    .like-content,\n    .share-content {\n        padding: 0 100px;\n    }\n\n    .activity-content h5,\n    .like-content h5,\n    .share-content h5 {\n        margin-top: 20px;\n    }\n\n    /*.mygroup .title-img-area .nature-text .nature-sub{*/\n    /*    padding-left: 0;*/\n    /*}*/\n}\n\n@media (max-width: 768px) {\n    .content-area .img-box {\n        height: 241px;\n    }\n\n    .image-button-box {\n        flex-wrap: wrap;\n        justify-content: start;\n    }\n    .tab-box-video {\n        align-items: baseline !important;\n    }\n    .tab-box-video ul {\n        margin-inline: 10px;\n    }\n    .right-arrow {\n        display: block;\n    }\n}\n\n@media (max-width: 600px) {\n\n    .activity-content,\n    .like-content,\n    .share-content {\n        padding: 0 15px;\n    }\n}\n\n@media (max-width: 575px) {\n    .view-all {\n        padding-top: 10px;\n    }\n\n    .mobile-view {\n        flex-direction: column;\n    }\n\n    .mobile-view .nature-sub {\n        padding-left: 0 !important;\n    }\n    .admin-area >div {\n        justify-content: flex-start !important;\n    }\n    .mygroup .content-page {\n        padding-inline: 20px;\n    }\n}\n\n@media (max-width: 475px) {\n    .mygroup .dis-middle .data-list .weekend .meni .lier {\n        flex-wrap: wrap;\n    }\n\n    .mygroup .dis-middle .data-list .weekend .meni .lier .sub-3 {\n        width: 100%;\n        margin-top: 8px;\n    }\n\n    .mygroup .dis-middle .data-list .weekend .meni .lier .sub-2.mr-3 {\n        margin-right: 0 !important;\n    }\n\n    .mygroup .dis-middle .data-list .weekend {\n        margin-bottom: 25px;\n    }\n\n    .view-all {\n        padding-top: 5px;\n    }\n}\n\n@media (max-width: 425px) {\n\n    .mygroup .admin-area .activeted .active-imger.active::after {\n        top: -3px;\n        right: -2px;\n        width: 10px;\n        height: 10px;\n    }\n\n    .btn-custom .group {\n        font-size: 14px;\n        height: 40px;\n    }\n\n    .mygroup .content-page .content-area h4 {\n        font-size: 19px;\n        margin-top: 10px;\n    }\n\n    .content-area .img-box {\n        height: 222px;\n    }\n\n    .mygroup .admin-area h2 {\n        font-size: 20px;\n        margin-bottom: 0;\n    }\n\n    .mygroup .admin-area .add-title {\n        font-size: 20px;\n        margin-bottom: 0;\n    }\n\n    .mygroup .discussion {\n        flex-wrap: wrap;\n    }\n\n    .mygroup .discussion button {\n        height: 40px;\n        max-width: none;\n    }\n\n    .mygroup .dis-middle .group-comp button {\n        height: 40px;\n    }\n\n    .mygroup .title-img-area .nature-text .nature-sub h5 {\n        font-size: 25px;\n    }\n\n    .mygroup .title-img-area .nature-text .nature-sub .group-title {\n        font-size: 20px;\n    }\n\n    .mygroup .discussion .mini-discussion input {\n        height: 40px;\n        text-indent: 31px;\n    }\n\n    .mygroup .discussion .mini-discussion img {\n        left: 6px;\n        top: 6px;\n        width: 28px;\n        height: 28px;\n    }\n\n    .activity-content,\n    .like-content,\n    .share-content {\n        margin-top: 20px;\n    }\n\n    .mygroup .title-img-area .nature-div {\n        min-width: 100%;\n    }\n}\n\n@media (max-width: 320px) {\n    .btn-custom .group {\n        width: 146px;\n    }\n\n    .mygroup .admin-area .activeted .active-imger {\n        width: 40px;\n        min-width: 40px;\n        height: 41px;\n    }\n\n    .mygroup .admin-area .activeted h6 {\n        font-size: 17px;\n    }\n\n    .mygroup .admin-area .activeted p {\n        font-size: 14px;\n    }\n\n    .activity-content h5,\n    .like-content h5,\n    .share-content h5 {\n        font-size: 20px;\n    }\n}\n\n.see-all {\n    position: absolute;\n    right: 22px;\n    top: 3px;\n    color: white;\n    cursor: pointer;\n}\n\n.c-cmt {\n    color: #6c2fbb;\n    cursor: pointer;\n}\n\n.rotate-180 {\n    -ms-transform: rotate(180deg);\n    /* IE 9 */\n    transform: rotate(180deg);\n}\n\n.reply-input {\n    /* border-left: 0;\n    border-right: 0;\n    border-top: 0;\n    border-bottom: 0.12rem solid #80808030;\n    outline: none; */\n}\n\n.reply-btn {\n    border: none;\n    background: #6c2fbb;\n    color: white;\n    padding: 2px 11px;\n    border-radius: 4px;\n    font-size: 15px;\n}\n\n.pro-img {\n    width: 50px;\n    height: 50px;\n    border-radius: 10px;\n    /*border-radius: 50%;*/\n    /* border: 1px solid gainsboro; */\n}\n\n#add_member .profile-image {\n    width: 50px;\n    min-width: 50px;\n    height: 50px;\n    font-size: 22px;\n    line-height: 30px;\n    border-radius: 10px;\n}\n\n.profile-image {\n    width: 50px;\n    height: 50px;\n    font-size: 20px;\n    border-radius: 9px;\n    /*    position: absolute;*/\n    /*    left: 8px;*/\n    /*    object-fit: cover;*/\n    /*    width: 27px;*/\n    /*    height: 27px;*/\n    /*    border-radius: 50%;*/\n    /*    border: 1px solid rgb(206 201 201);*/\n    /*    background: none;*/\n}\n\n.input-search {\n    position: relative;\n}\n\n.input-search-admin {\n    padding-left: 28px;\n    position: relative;\n}\n\n.input-searchs {\n    padding-left: 32px;\n}\n\n.fa-search {\n    position: absolute;\n    top: 10px;\n    left: 23px;\n    z-index: 1;\n    color: #495057a3;\n}\n\nselect:not(.admin-select) {\n    border: none;\n    background: no-repeat;\n    position: relative;\n    top: -5px;\n    color: rgb(0, 0, 0);\n}\n\n.memmber-list {\n    color: rgb(0, 0, 0);\n    /* margin-right: -31px;\n    margin-left: -31px; */\n    padding: 7px 0px;\n    cursor: pointer;\n    height: 300;\n    overflow-x: hidden;\n}\n\n.m-list1 {\n    /*background-color: #6c2fbb !important;*/\n    background-color: #f2f2f2 !important;\n    color: rgb(0, 0, 0);\n}\n\n.m-list2 {\n    /*background-color: #6c2fbb !important;*/\n    background-color: #f2f2f2 !important;\n    /*color: rgb(243, 243, 243);*/\n    color: rgb(0, 0, 0);\n    padding: 7px 0px;\n}\n\n.lecture-name {\n    margin-bottom: 0rem;\n}\n\n.select-first {\n    color: rgb(0, 0, 0);\n}\n\n.select-first option {\n    color: rgb(0, 0, 0);\n}\n\n.afterselect {\n    color: white;\n}\n\n.member-view:hover {\n    text-decoration: underline;\n}\n\n.private-view:hover {\n    text-decoration: underline;\n}\n\n#upload-photo {\n    opacity: 0;\n    position: absolute;\n    z-index: -1;\n}\n\n.save-btn {\n    text-align: center;\n    border: none;\n    outline: none;\n    background: none;\n    background: #6c2fbb;\n    /*opacity: 0.8;*/\n    color: white;\n    font-size: 15px;\n    padding: 6px 31px;\n    border-radius: 5px;\n}\n\n.video-views {\n    height: 300px;\n    overflow-y: scroll;\n    overflow-x: hidden;\n}\n\ntable {\n    margin-bottom: 18px;\n    border-collapse: collapse;\n    border-spacing: 0;\n    width: 100%;\n    /* border: 1px solid #ddd; */\n}\n\nth,\ntd,\nth {\n    text-align: left;\n    padding: 7px;\n    font-size: 14px;\n}\n\n/* tr:nth-child(even) {\n    background-color: #f2f2f2;\n} */\n\n#table_header {\n    background: #8600ff;\n    color: white;\n    font-size: 14px;\n    height: 53px !important;\n    box-shadow: 0px 0px 5px 0px rgb(0 0 0 / 20%);\n}\n\n.table-view {\n    height: 276px;\n    overflow: scroll;\n    margin-bottom: 24px;\n    /* border: 1px solid #80808029; */\n}\n\n#view_member .profile-image {\n    width: 50px;\n    min-width: 50px;\n    height: 50px;\n    font-size: 22px;\n    line-height: 30px;\n    border-radius: 10px;\n    /*margin-right: 0;*/\n    /*margin-right: 0;*/\n}\n\n.member-admin-profile {\n    height: 50px;\n    width: 50px;\n    object-fit: cover;\n    /* object-fit: contain; */\n    /*border-radius: 50%;*/\n    border-radius: 10px;\n    /*border: 2px solid white !important;*/\n}\n\n.dropdown-menu {\n    z-index: 1;\n}\n\n.dropdown-item {\n    border-bottom: 0;\n    padding: 3px 10px;\n    /*padding: 0;*/\n}\n\n.dropdown-item:hover {\n    background-color: #f2f2f2;\n    color: black;\n}\n\n/*.drop-menus {*/\n/*    transform: translate3d(-82px, -3px, 0px) !important;*/\n/*    min-width: 83px !important;*/\n/*}*/\n\n.select-drop {\n    font-size: 13px;\n    padding: 0;\n    border: 1px solid #8080802b;\n    height: 23px !important;\n    margin-top: 8px;\n}\n\n.privacy-text {\n    position: absolute;\n    left: 0;\n    top: 19px;\n}\n\n.custom-control {\n    position: relative !important;\n    top: -25px;\n}\n\n.update-btn {\n    border: none;\n    background: #8600ff;\n    border-radius: 5px;\n    color: white;\n    padding: 4px 30px;\n}\n\n.FF-scroll-modify {\n    display: none;\n    height: 100% !important;\n    max-height: 625px;\n    scroll-behavior: smooth;\n    touch-action: auto;\n}\n\n.more-images {\n    background: #F5F5F5 !important;\n    border: 1px solid #727272 !important;\n    color: #727272;\n}\n\n.group-list-new {\n    background: #FFFFFF;\n    padding: 15px 20px;\n    border: 1px solid #F8F8F8;\n    border-radius: 16px;\n}\n\n.group-list-img {\n    object-fit: contain;\n    width: 70px !important;\n    height: 70px;\n    margin: 0 auto;\n\n    /*box-shadow: 0px 0px 2px 0px rgb(0 0 0 / 50%) !important*/\n}\n\n.owl-carousel-two .img-box:hover {\n    border-radius: 9px;\n}\n\n.owl-carousel-two .img-box-create {\n    box-shadow: 0px 0px 2px 0px rgb(0 0 0 / 50%) !important;\n    margin: 2px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    flex-direction: column;\n    width: 68px;\n    height: 68px;\n    color: #6c2fbb;\n}\n\n.owl-carousel-two .img-box {\n    overflow: hidden;\n    border-radius: 50px;\n    transition: 0.5s;\n    cursor: pointer;\n    /*position: relative;*/\n    margin: 1px 1px 16px;\n}\n\n/* \n.owl-carousel-two .img-box.active:after {\n    content: \"\";\n    position: absolute;\n    height: 100%;\n    width: 100%;\n    bottom: 0;\n    right: auto;\n    left: auto;\n    background-image: radial-gradient(circle at center, #6c2fbb 4px, transparent 5px);\n    background-size: 15px 15px;\n    background-position: bottom center;\n    background-repeat: no-repeat;\n} */\n\n.activeClass span {\n    background: #6c2fbb;\n    height: 8px;\n    width: 8px;\n    border-radius: 100%;\n    display: block;\n}\n\n.owl-carousel-two .img-box.premium {\n    box-shadow: 0 0 2px 1px #6c2fbb !important;\n    width: auto;\n    margin-right: 10px;\n}\n\n.owl-carousel-two {\n    max-width: 95%;\n    margin: 0 auto;\n}\n\n.replysection:hover .replyDelete {\n    display: flex;\n    justify-content: end;\n    padding-right: 15px;\n    gap: 5px;\n}\n\n.replyDelete {\n    display: none;\n    text-align: center;\n}\n\n.replyDelete button {\n    background-color: #c401ec;\n    width: 59px;\n    height: 30px;\n    border-radius: 5px;\n    font-weight: 400;\n    font-size: 12px;\n    color: #ffffff;\n    border: 0;\n}\n.replyDelete button.up {\n    background-color: #6c2fbb;\n}\n\n@media (max-width: 1024px) {\n    .owl-carousel-two {\n        max-width: 86%;\n    }\n}\n\n@media (max-width: 512px) {\n\n    .group-list-img,\n    .img-box-create {\n        width: 60px !important;\n        height: 60px !important;\n    }\n}\n\n.planBadge {\n    cursor: pointer;\n    display: inline-block;\n    overflow: hidden;\n    background: #e1e1f9;\n    border-radius: 20px;\n    border: none;\n    outline: none;\n    color: #6438b4;\n    padding: 5px 15px;\n    margin-top: 10px;\n    font-weight: bold;\n    font-size: 14px;\n}\n\n.btn-show-password {\n    position: absolute;\n    right: 0;\n    top: 0;\n}\n\n\n/*tab boxed*/\n\n\n.tab-box-video {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\n.tab-box-video ul {\n    display: flex;\n    align-items: center;\n    white-space: nowrap;\n    overflow: auto;\n    width: 100%;\n    margin:0;\n    scrollbar-width: none;\n    /* justify-content: center; */\n}\n\n.tab-box-video ul li {\n    position: relative;\n    list-style: none;\n    /* font-weight: 500; */\n    font-size: 18px;\n    padding: 5px 10px 0 10px;\n    margin: 0 15px;\n    color: #878395;\n    cursor: pointer;\n}\n\n.tab-box-video ul li svg {\n    fill: #878395;\n}\n\n.tab-box-video ul li.active {\n    border-top: 3px solid #6c2fbb;\n    color: #6c2fbb;\n}\n\n.tab-box-video ul li.active svg {\n    fill: rgba(108, 47, 187, 1);\n}\n\n.tab-box-video ul li .add-tab {\n    color: #6c2fbb;\n    background: #e1e1f9;\n    height: 30px;\n    width: 30px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\n.tab-box-video ul li .delete-tab {\n    position: absolute;\n    right: -10px;\n    display: none;\n    color: #dc3545;\n    top: 6px;\n}\n\n.tab-box-video ul li .edit-tab svg {\n    height: 16px;\n    width: 16px;\n    fill: black;\n    margin-left: 3px;\n    display: none;\n}\n\n.pinImage{\n    display: none;\n}\n\n.tab-box-video ul li:hover .delete-tab {\n    display: inline-block;\n}\n\n.tab-box-video ul li:hover .edit-tab svg {\n    display: inline-block;\n}\n.tab-box-video ul li:hover .pinImage {\n    display: inline-block;\n    position: unset;\n}\n\n.isPinned{\n    background-color: #f1eafe8c;\n    border: 1px solid #ae88df;\n    border-radius: 4px;\n}\n\n.discussionBoard h2 {\n    width: 100%;\n    max-width: fit-content;\n}\n\n.discussionBoard .tab-box-video ul li .delete-tab {\n    display: none;\n    color: #dc3545;\n    position: unset;\n    padding: 0 5px 0 5px;\n}\n\n.discussionBoard .tab-box-video ul li:hover .delete-tab {\n    display: inline-block;\n}\n.customMenu h6 {\n    font-size: 18px;\n}\n\n::ng-deep .tooltip001 {\n    position: absolute;\n    background-color: white;\n    border: 1px solid #ccc;\n    padding: 10px 13px;\n    box-shadow: 0 2px 5px rgba(0,0,0,0.1);\n    z-index: 1000; \n}\n::ng-deep .tooltip001 span {\n   display: flex;\n   align-items: center;\n   gap: 10px;\n}\n::ng-deep .tooltip001 img {\n    width: 50px;\n    height: 50px;\n    border-radius: 5px;\n}\n::ng-deep .tooltip001 .profile-image {\n    width: 50px;\n    height: 50px;\n    border-radius: 5px;\n    font-size: 18px;\n}\n::ng-deep .modal-backdrop.fade:not(.show) {\n    display: none;\n}\n\n.tab-box-video ul::-webkit-scrollbar {\n    height: 4px;\n}\n\n.recorder-playlist {\n    position: unset;\n    display: inline-flex;\n}\n.recorder-playlist .btn-sm {\n    background-color: #e1e1f9;\n    padding: 0;\n    width: 25px;\n    height: 25px;\n    margin-right: 4px;\n}\n.recorder-playlist span,\n.recorder-playlist .btn-sm i {\n    color: #6c2fbb;\n}\n.action-tab {\n    width: 30px;\n    height: 30px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    border-radius: 6px;\n    background: #ffffff;\n    color: #000000;\n    border: 1px solid #cdcdcd;\n    font-size: 14px;\n    cursor: pointer;\n}\n.action-tab svg {\n    fill: #000000;\n}\n.action-tab:hover {\n    border-color: #6c2fbb;\n    background: #f1eafe;\n    color: #6c2fbb;\n}\n.action-tab:hover svg {\n    fill: #6c2fbb;\n}\n\n@media (max-width: 1400px) {\n    .tab-box-video ul li {\n        font-size: 18px;\n        white-space: nowrap;\n    }\n    .lastReply {\n        white-space: nowrap;\n    }\n\n}\n\n@media (max-width: 1200px) {\n    .tab-box-video ul {\n        overflow-x: auto;\n        padding-bottom: 10px;\n\n    }\n\n    \n}\n\n@media (max-width: 768px) {\n    .tab-box-video ul {\n        justify-content: start;\n    }\n\n    .tab-box-video ul li {\n        font-size: 17px;\n    }\n}\n@media (max-width: 767px) {\n    #offcanvasRight .reply {\n        width: 97%;\n    }\n} \n@media (max-width: 575px) {\n    .memmber-list {\n        flex-wrap: nowrap;\n        gap: 10px;\n    }\n    .memmber-list .member-check {\n        padding: 0;\n    }\n    .memmber-list .member-img {\n        padding: 0;\n    }\n} \n@media (max-width: 480px) {\n    ::ng-deep ngx-link.NgxEditor__MenuItem .NgxEditor__Popup {\n        right: 0;\n    }\n    #offcanvasRight .demo {\n        height: calc(100vh - 372px);\n    }\n    .btn-invite {\n        margin-top: 0;\n        margin-bottom: 10px;\n    }\n    .btn-invite span {\n        white-space: nowrap;\n    }\n}\n@media (max-width: 430px) {\n    ::ng-deep ngx-image.NgxEditor__MenuItem .NgxEditor__Popup {\n        left: 0;\n    }\n}\n@media (max-width: 385px) {\n    ::ng-deep ngx-link.NgxEditor__MenuItem .NgxEditor__Popup {\n        left: 0;\n    }\n}\n@media (min-width: 1400px) {\n    .col-xxl-10 {\n        flex: 0 0 auto;\n        max-width: 83.33333333%;\n    }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
